{
  "about.blocks": "Netþjónar með efnisumsjón",
  "about.contact": "Hafa samband:",
  "about.default_locale": "Sjálfgefið",
  "about.disclaimer": "Mastodon er frjáls hugbúnaður með opinn grunnkóða og er skrásett vörumerki í eigu Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Ástæða ekki tiltæk",
  "about.domain_blocks.preamble": "Mastodon leyfir þér almennt að skoða og eiga við efni frá notendum frá hvaða vefþjóni sem er í vefþjónasambandinu. Þetta eru þær undantekningar sem hafa verið gerðar á þessum tiltekna vefþjóni.",
  "about.domain_blocks.silenced.explanation": "Þú munt almennt ekki sjá notandasnið og efni af þessum netþjóni nema þú flettir því upp sérstaklega eða veljir að fylgjast með því.",
  "about.domain_blocks.silenced.title": "Takmarkað",
  "about.domain_blocks.suspended.explanation": "Engin gögn frá þessum vefþjóni verða unnin, geymd eða skipst á, sem gerir samskipti við notendur frá þessum vefþjóni ómöguleg.",
  "about.domain_blocks.suspended.title": "Í frysti",
  "about.language_label": "Tungumál",
  "about.not_available": "Þessar upplýsingar hafa ekki verið gerðar aðgengilegar á þessum netþjóni.",
  "about.powered_by": "Dreifhýstur samskiptamiðill keyrður með {mastodon}",
  "about.rules": "Reglur netþjónsins",
  "account.account_note_header": "Mínir minnispunktar",
  "account.activity": "Virkni",
  "account.add_note": "Bæta við persónulegum minnispunkti",
  "account.add_or_remove_from_list": "Bæta við eða fjarlægja af listum",
  "account.badges.admin": "Stjóri",
  "account.badges.blocked": "Útilokað",
  "account.badges.bot": "Yrki",
  "account.badges.domain_blocked": "Útilokað lén",
  "account.badges.group": "Hópur",
  "account.badges.muted": "Þaggað",
  "account.badges.muted_until": "Þaggað til {until}",
  "account.block": "Loka á @{name}",
  "account.block_domain": "Útiloka lénið {domain}",
  "account.block_short": "Útiloka",
  "account.blocked": "Útilokaður",
  "account.cancel_follow_request": "Taka fylgjendabeiðni til baka",
  "account.copy": "Afrita tengil í notandasnið",
  "account.direct": "Einkaspjall við @{name}",
  "account.disable_notifications": "Hætta að láta mig vita þegar @{name} sendir inn",
  "account.edit_note": "Breyta persónulegum minnispunkti",
  "account.edit_profile": "Breyta notandasniði",
  "account.edit_profile_short": "Breyta",
  "account.enable_notifications": "Láta mig vita þegar @{name} sendir inn",
  "account.endorse": "Birta á notandasniði",
  "account.familiar_followers_many": "Fylgt af {name1}, {name2} og {othersCount, plural, one {einum öðrum sem þú þekkir} other {# öðrum sem þú þekkir}}",
  "account.familiar_followers_one": "Fylgt af {name1}",
  "account.familiar_followers_two": "Fylgt af {name1} og {name2}",
  "account.featured": "Með aukið vægi",
  "account.featured.accounts": "Notendasnið",
  "account.featured.collections": "Söfn",
  "account.featured.new_collection": "Nýtt safn",
  "account.field_overflow": "Birta allt efnið",
  "account.filters.all": "Öll virkni",
  "account.filters.boosts_toggle": "Sýna endurbirtingar",
  "account.filters.posts_boosts": "Færslur og endurbirtingar",
  "account.filters.posts_only": "Færslur",
  "account.filters.posts_replies": "Færslur og svör",
  "account.filters.replies_toggle": "Birta svör",
  "account.follow": "Fylgjast með",
  "account.follow_back": "Fylgjast með til baka",
  "account.follow_back_short": "Fylgja líka",
  "account.follow_request": "Beiðni um að fylgja",
  "account.follow_request_cancel": "Hætta við beiðni",
  "account.follow_request_cancel_short": "Hætta við",
  "account.follow_request_short": "Beiðni",
  "account.followers": "Fylgjendur",
  "account.followers.empty": "Ennþá fylgist enginn með þessum notanda.",
  "account.followers_counter": "{count, plural, one {Fylgjandi: {counter}} other {Fylgjendur: {counter}}}",
  "account.followers_you_know_counter": "{counter} sem þú þekkir",
  "account.following": "Fylgist með",
  "account.following_counter": "{count, plural, one {Fylgist með: {counter}} other {Fylgist með: {counter}}}",
  "account.follows.empty": "Þessi notandi fylgist ennþá ekki með neinum.",
  "account.follows_you": "Fylgir þér",
  "account.go_to_profile": "Fara í notandasnið",
  "account.hide_reblogs": "Fela endurbirtingar fyrir @{name}",
  "account.in_memoriam": "Minning.",
  "account.join_modal.day": "daginn",
  "account.join_modal.me": "Þú skráðir þig á {server} þann",
  "account.join_modal.me_anniversary": "Til hamingju með daginn! Þú skráðir þig á {server} þann",
  "account.join_modal.me_today": "Þetta er fyrsti dagurinn þinn á {server}!",
  "account.join_modal.other": "{name} skráði sig á {server} þann",
  "account.join_modal.other_today": "Þetta er fyrsti dagurinn hjá {name} á {server}!",
  "account.join_modal.share.celebrate": "Deila fagnaðarfærslu",
  "account.join_modal.share.intro": "Deila kynningarfærslu",
  "account.join_modal.share.welcome": "Deila móttökufærslu",
  "account.join_modal.years": "{number, plural, one {ár} other {ár}}",
  "account.joined_short": "Gerðist þátttakandi",
  "account.languages": "Breyta tungumálum í áskrift",
  "account.last_active": "Síðasta virkni",
  "account.link_verified_on": "Eignarhald á þessum tengli var athugað þann {date}",
  "account.locked_info": "Staða gagnaleyndar á þessum aðgangi er stillt á læsingu. Eigandinn yfirfer handvirkt hverjir geti fylgst með honum.",
  "account.media": "Myndefni",
  "account.mention": "Minnast á @{name}",
  "account.menu.add_to_list": "Bæta á lista…",
  "account.menu.block": "Útiloka notandaaðgang",
  "account.menu.block_domain": "Útiloka {domain}",
  "account.menu.copied": "Afritaði tengil á notandaaðgang á klippispjald",
  "account.menu.copy": "Afrita tengil",
  "account.menu.direct": "Minnast á í einkaspjalli",
  "account.menu.hide_reblogs": "Fela endurbirtingar í tímalínu",
  "account.menu.mention": "Minnst á",
  "account.menu.mute": "Þagga niður í aðgangi",
  "account.menu.note.description": "Einungis sýnilegt þér",
  "account.menu.open_original_page": "Skoða á {domain}",
  "account.menu.remove_follower": "Fjarlægja fylgjanda",
  "account.menu.report": "Tilkynna aðgang",
  "account.menu.share": "Deila…",
  "account.menu.show_reblogs": "Sýna endurbirtingar í tímalínu",
  "account.menu.unblock": "Aflétta útilokun aðgangs",
  "account.menu.unblock_domain": "Aflétta útilokun á {domain}",
  "account.menu.unmute": "Hætta að þagga niður í aðgangi",
  "account.moved_to": "{name} hefur gefið til kynna að nýi notandaaðgangurinn sé:",
  "account.mute": "Þagga niður í @{name}",
  "account.mute_notifications_short": "Þagga í tilkynningum",
  "account.mute_short": "Þagga niður",
  "account.muted": "Þaggaður",
  "account.mutual": "Þið fylgið hvor öðrum",
  "account.name.copy": "Afrita kennislóð",
  "account.name.help.domain": "{domain} er netþjónninn sem hýsir upplýsingasnið um notandann og færslurnar hans.",
  "account.name.help.domain_self": "{domain} er netþjónninn þinn sem hýsir upplýsingasniðið þitt og færslurnar þínar.",
  "account.name.help.footer": "Rétt eins og að þú getur sent tölvupóst á fólk í gegnum mismunandi þjónustur og forrit, þá getur þú átt í samskiptum við fólk á öðrum Mastodon-netþjónum, og reyndar við hverja þá sem eru á öðrum þeim forritum sem nota sömu samskiptareglur Fediverse-samfélagsins.",
  "account.name.help.header": "Kennislóð (handle) líkist tölvupóstfangi",
  "account.name.help.username": "{username} er notandanafn þessa aðgangs á netþjóni viðkomandi. Einhver annar á öðrum netþjóni getur verið með sama notandanafnið.",
  "account.name.help.username_self": "{username} er notandanafnið þitt á þessum netþjóni. Einhver annar á öðrum netþjóni getur verið með sama notandanafnið.",
  "account.name_info": "Hvað þýðir þetta?",
  "account.no_bio": "Engin lýsing gefin upp.",
  "account.node_modal.callout": "Persónulegir einkaminnispunktar eru einungis sýnilegir þér.",
  "account.node_modal.edit_title": "Breyta einkaminnispunkti",
  "account.node_modal.error_unknown": "Tókst ekki að vista minnispunktinn",
  "account.node_modal.field_label": "Einkaminnispunktur",
  "account.node_modal.save": "Vista",
  "account.node_modal.title": "Bæta við einkaminnispunkti",
  "account.note.edit_button": "Breyta",
  "account.note.title": "Einkaminnispunktur (einungis sýnilegur þér)",
  "account.open_original_page": "Opna upprunalega síðu",
  "account.pending": "Í bið",
  "account.posts": "Færslur",
  "account.remove_from_followers": "Fjarlægja {name} úr fylgjendum",
  "account.report": "Kæra @{name}",
  "account.requested_follow": "{name} hefur beðið um að fylgjast með þér",
  "account.share": "Deila notandasniði fyrir @{name}",
  "account.show_reblogs": "Sýna endurbirtingar frá @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} færsla} other {{counter} færslur}}",
  "account.timeline.pinned": "Fest",
  "account.timeline.pinned.view_all": "Skoða allar festar færslur",
  "account.unblock": "Aflétta útilokun af @{name}",
  "account.unblock_domain": "Aflétta útilokun lénsins {domain}",
  "account.unblock_domain_short": "Aflétta útilokun",
  "account.unblock_short": "Hætta að loka á",
  "account.unendorse": "Ekki birta á notandasniði",
  "account.unfollow": "Hætta að fylgja",
  "account.unmute": "Hætta að þagga niður í @{name}",
  "account.unmute_notifications_short": "Hætta að þagga í tilkynningum",
  "account.unmute_short": "Hætta að þagga niður",
  "account_edit.advanced_settings.bot_hint": "Merki til annarra að þessi aðgangur sé aðallega til að framkvæma sjálfvirkar aðgerðir og gæti verið án þess að hann sé vaktaður reglulega",
  "account_edit.advanced_settings.bot_label": "Sjálfvirkur aðgangur",
  "account_edit.advanced_settings.title": "Ítarlegar stillingar",
  "account_edit.bio.add_label": "Bættu við æviágripi",
  "account_edit.bio.edit_label": "Breyta æviágripi",
  "account_edit.bio.placeholder": "Settu inn stutta kynningu á þér svo aðrir eigi betur með að auðkenna þig.",
  "account_edit.bio.title": "Æviágrip",
  "account_edit.bio_modal.add_title": "Bættu við æviágripi",
  "account_edit.bio_modal.edit_title": "Breyta æviágripi",
  "account_edit.column_button": "Lokið",
  "account_edit.column_title": "Breyta notandasniði",
  "account_edit.custom_fields.add_label": "Bæta við reit",
  "account_edit.custom_fields.edit_label": "Breyta reit",
  "account_edit.custom_fields.placeholder": "Settu inn fornöfn sem þú vilt nota, ytri tengla eða hvaðeina sem þú vilt deila með öðrum.",
  "account_edit.custom_fields.reorder_button": "Endurraða reitum",
  "account_edit.custom_fields.tip_content": "Þú getur á einfaldan hátt aukið trúverðugleika Mastodon-aðgangsins þíns með því að bæta við staðfestingartenglum sem vísa á vefsvæði sem þú átt.",
  "account_edit.custom_fields.tip_title": "Ábending: Bæta við staðfestingartenglum",
  "account_edit.custom_fields.title": "Sérsniðnir reitir",
  "account_edit.custom_fields.verified_hint": "Hvernig bæti ég við staðfestingartengli?",
  "account_edit.display_name.add_label": "Bættu við birtingarnafni",
  "account_edit.display_name.edit_label": "Breyta birtingarnafni",
  "account_edit.display_name.placeholder": "Birtingarnafn er það sem birtist sem nafnið þitt á notandasniðinu þínu og í tímalínum.",
  "account_edit.display_name.title": "Birtingarnafn",
  "account_edit.featured_hashtags.edit_label": "Bæta við myllumerkjum",
  "account_edit.featured_hashtags.placeholder": "Hjálpaðu öðrum að sjá og komast í eftirlætis-umfjöllunarefnin þín.",
  "account_edit.featured_hashtags.title": "Myllumerki með aukið vægi",
  "account_edit.field_actions.delete": "Eyða reit",
  "account_edit.field_actions.edit": "Breyta reit",
  "account_edit.field_delete_modal.confirm": "Ertu viss um að þú viljir eyða þessum sérsniðna reit? Þessa aðgerð er ekki hægt að afturkalla.",
  "account_edit.field_delete_modal.delete_button": "Eyða",
  "account_edit.field_delete_modal.title": "Eyða sérsniðnum reit?",
  "account_edit.field_edit_modal.add_title": "Bæta við sérsniðnum reit",
  "account_edit.field_edit_modal.discard_confirm": "Henda",
  "account_edit.field_edit_modal.discard_message": "Þú ert með óvistaðar breytingar, ertu viss um að þú viljir henda þeim?",
  "account_edit.field_edit_modal.edit_title": "Breyta sérsniðnum reit",
  "account_edit.field_edit_modal.length_warning": "Hámarksfjölda stafa er náð. Farsímanotendur ná mögulega ekki að sjá allan reitinn hjá þér.",
  "account_edit.field_edit_modal.link_emoji_warning": "Við mælum gegn því að nota sérsniðin tjáningartákn saman með vefslóðum. Sérsniðnir reitir sem innihalda hvort tveggja munu birtast sem einungis texti í stað þess að vera tenglar, til að koma í veg fyrir að notendur taki annað í misgripum fyrir hitt.",
  "account_edit.field_edit_modal.name_hint": "T.d. \"Eigið vefsvæði\"",
  "account_edit.field_edit_modal.name_label": "Skýring",
  "account_edit.field_edit_modal.url_warning": "Til að bæta við tengli skaltu hafa {protocol} á undan.",
  "account_edit.field_edit_modal.value_hint": "T.d. “https://vefur.is”",
  "account_edit.field_edit_modal.value_label": "Gildi",
  "account_edit.field_reorder_modal.drag_cancel": "Hætt var við að draga. Reitnum \"{item}\" var sleppt.",
  "account_edit.field_reorder_modal.drag_end": "Reitnum \"{item}\" var sleppt.",
  "account_edit.field_reorder_modal.drag_instructions": "Til að endurraða sérsniðnum reitum skaltu ýta á bilslá eða Enter. Á meðan verið er að draga geturðu notað örvalyklana til að færa reitinn upp eða niður. Ýttu aftur á bilslá eða Enter til að to sleppa reitnum á nýja staðinn sinn, eða ýtt á Escape til að hætta við.",
  "account_edit.field_reorder_modal.drag_move": "Reiturinn \"{item}\" var færður.",
  "account_edit.field_reorder_modal.drag_over": "Reiturinn \"{item}\" var færður yfir \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Náði reitnum \"{item}\".",
  "account_edit.field_reorder_modal.handle_label": "Dragðu reitinn \"{item}\"",
  "account_edit.field_reorder_modal.title": "Endurraða gagnasviðum",
  "account_edit.image_alt_modal.add_title": "Bæta við hjálpartexta",
  "account_edit.image_alt_modal.details_content": "GERÐU ÞETTA: <ul> <li>Lýstu þér eins og þú ert á myndinni</li> <li>Notaðu þriðjupersónu (t.d. “Nonni” í staðinn fyrir “ég”)</li> <li>Vertu stuttorð/ur – fá orð eru oft nóg</li> </ul> EKKI GERA ÞETTA: <ul> <li>Byrja á “Mynd af” – það er óþarft fyrir skjálesara</li> </ul> DÆMI: <ul> <li>“Nonni í grænni skyrtu og með gleraugu”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Ábending: hjálpartexti fyrir auðkennismyndir",
  "account_edit.image_alt_modal.edit_title": "Breyta hjálpartexta",
  "account_edit.image_alt_modal.text_hint": "Hjálpartexti hjálpar fólki sem notar skjálesara að skilja efnið frá þér.",
  "account_edit.image_alt_modal.text_label": "Hjálpartexti mynda",
  "account_edit.image_delete_modal.confirm": "Ertu viss um að þú viljir eyða þessari mynd? Þessa aðgerð er ekki hægt að afturkalla.",
  "account_edit.image_delete_modal.delete_button": "Eyða",
  "account_edit.image_delete_modal.title": "Eyða mynd?",
  "account_edit.image_edit.add_button": "Bæta við mynd",
  "account_edit.image_edit.alt_add_button": "Bæta við hjálpartexta",
  "account_edit.image_edit.alt_edit_button": "Breyta hjálpartexta",
  "account_edit.image_edit.remove_button": "Fjarlægja mynd",
  "account_edit.image_edit.replace_button": "Skipta um mynd",
  "account_edit.item_list.delete": "Eyða {name}",
  "account_edit.item_list.edit": "Breyta {name}",
  "account_edit.name_modal.add_title": "Bættu við birtingarnafni",
  "account_edit.name_modal.edit_title": "Breyta birtingarnafni",
  "account_edit.profile_tab.button_label": "Sérsníða",
  "account_edit.profile_tab.hint.description": "Þessar stillingar sérsníða hvað notendur sjá á {server} í opinberu forritunum, en ekki er víst hvernig þetta virkar fyrir notendur á öðrum netþjónum og utanaðkomandi forritum.",
  "account_edit.profile_tab.hint.title": "Birting er ennþá breytileg",
  "account_edit.profile_tab.show_featured.description": "'Með aukið vægi' er valkvæður flipi þar sem þú getur kynnt aðra notendaaðganga.",
  "account_edit.profile_tab.show_featured.title": "Birta 'Með aukið vægi' flipa",
  "account_edit.profile_tab.show_media.description": "‘Myndefni’ er valkvæður flipi þar sem birtast þær færslur þínar sem innihalda myndir eða myndskeið.",
  "account_edit.profile_tab.show_media.title": "Birta 'Myndefni' flipa",
  "account_edit.profile_tab.show_media_replies.description": "Þegar þetta er virkt, sýnir myndefnisflipinn bæði færslurnar þínar og svör þín við færslum annarra.",
  "account_edit.profile_tab.show_media_replies.title": "Hafa með svör á flipanum ‘Myndefni’",
  "account_edit.profile_tab.show_relations.description": "Birtir öðrum notendum á notandasniðinu þínu þá aðganga sem þú fylgist með og sem fylgjast með þér. Fólk mun áfram geta séð hvort þú fylgist með þeim.",
  "account_edit.profile_tab.show_relations.title": "Sýna 'Fylgjendur’ og 'Fylgist með'",
  "account_edit.profile_tab.subtitle": "Sérsníddu hvernig notandasniðið þitt birtist.",
  "account_edit.profile_tab.title": "Stillingar á birtingu notandasniðs",
  "account_edit.save": "Vista",
  "account_edit.upload_modal.back": "Til baka",
  "account_edit.upload_modal.done": "Lokið",
  "account_edit.upload_modal.next": "Næsta",
  "account_edit.upload_modal.step_crop.zoom": "Aðdráttur",
  "account_edit.upload_modal.step_upload.button": "Skoða skrár",
  "account_edit.upload_modal.step_upload.dragging": "Slepptu til að senda inn",
  "account_edit.upload_modal.step_upload.header": "Veldu mynd",
  "account_edit.upload_modal.step_upload.hint": "WEBP, PNG, GIF eða JPG-snið, allt að {limit}MB.{br}Mynd verður kvörðuð í {width}x{height}px.",
  "account_edit.upload_modal.title_add.avatar": "Bæta við auðkennismynd",
  "account_edit.upload_modal.title_add.header": "Bæta við mynd í haus",
  "account_edit.upload_modal.title_replace.avatar": "Skipta um auðkennismynd",
  "account_edit.upload_modal.title_replace.header": "Skipta um mynd í haus",
  "account_edit.verified_modal.details": "Auktu trúverðugleika Mastodon-aðgangsins þíns með því að bæta við staðfestingartenglum sem vísa á vefsvæðin þín. Hérna sérðu hvernig það virkar:",
  "account_edit.verified_modal.invisible_link.details": "Bættu tenglinum í hausinn hjá þér. Mikilvægi hlutinn er rel=\"me\" sem kemur í veg fyrir blekkingu verðandi persónuauðkenni á vefsvæðum með notandaframleiddu efni. Þú getur jafnvel notað tengimerkið í haus síðunnar í staðinn fyrir {tag}, en HTML-kóðinn verður samt að vera aðgengilegur án þess að keyra þurfi JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Hvernig geri ég tengilinn ósýnilegan?",
  "account_edit.verified_modal.step1.header": "Afritaðu HTML-kóðann hér fyrir neðan og límdu hann inn í haus vefsvæðisins þíns",
  "account_edit.verified_modal.step2.details": "Ef þú hefur þegar bættu vefsvæðinu þínu inn sem sérsniðnum reit, þá muntu þurfa að eyða honum og bæta við aftur til að gangsetja sannvottun.",
  "account_edit.verified_modal.step2.header": "Bættu vefsvæðinu þínu inn sem sérsniðinn reit",
  "account_edit.verified_modal.title": "Hvernig er hægt að bæta við staðfestingartengli",
  "account_edit_tags.add_tag": "Bæta við #{tagName}",
  "account_edit_tags.column_title": "Breyta merkjum",
  "account_edit_tags.help_text": "Myllumerki með aukið vægi hjálpa lesendum að finna og eiga við notandasíðuna þína. Þau birtast sem síur í virkniflipa notandasíðunnar þinnar.",
  "account_edit_tags.max_tags_reached": "Þú hefur náð hámarksfjölda myllumerkja með aukið vægi.",
  "account_edit_tags.search_placeholder": "Settu inn myllumerki…",
  "account_edit_tags.suggestions": "Tillögur:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# færsla} other {# færslur}}",
  "account_list.hidden_notice": "Þetta er aðeins sýnilegt þér. Til að sýna öðrum þennan lista, skaltu fara á <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# aðgangur} other {# aðgangar}}",
  "account_note.placeholder": "Smelltu til að bæta við minnispunkti",
  "admin.dashboard.daily_retention": "Hlutfall virkra notenda eftir nýskráningu eftir dögum",
  "admin.dashboard.monthly_retention": "Hlutfall virkra notenda eftir nýskráningu eftir mánuðum",
  "admin.dashboard.retention.average": "Meðaltal",
  "admin.dashboard.retention.cohort": "Mánuður nýskráninga",
  "admin.dashboard.retention.cohort_size": "Nýir notendur",
  "admin.impact_report.instance_accounts": "Notendaaðgangar sem þetta myndi eyða",
  "admin.impact_report.instance_followers": "Fylgjendur sem notendur okkar myndu tapa",
  "admin.impact_report.instance_follows": "Fylgjendur sem þeirra notendur myndu tapa",
  "admin.impact_report.title": "Samantekt áhrifa",
  "alert.rate_limited.message": "Prófaðu aftur eftir {retry_time, time, medium}.",
  "alert.rate_limited.title": "Með takmörkum",
  "alert.unexpected.message": "Upp kom óvænt villa.",
  "alert.unexpected.title": "Úbbs!",
  "alt_text_badge.title": "Hjálpartexti mynda",
  "alt_text_modal.add_alt_text": "Bæta við hjálpartexta",
  "alt_text_modal.add_text_from_image": "Bæta við texta úr mynd",
  "alt_text_modal.cancel": "Hætta við",
  "alt_text_modal.change_thumbnail": "Skipta um smámynd",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Lýstu þessu fyrir fólk með skerta heyrn…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Lýstu þessu fyrir fólk með skerta sjón…",
  "alt_text_modal.done": "Lokið",
  "announcement.announcement": "Auglýsing",
  "annual_report.announcement.action_build": "Búa til ársuppgjör fyrir mig",
  "annual_report.announcement.action_dismiss": "Nei takk",
  "annual_report.announcement.action_view": "Skoða ársuppgjörið mitt",
  "annual_report.announcement.description": "Skoðaðu meira um virkni þína á Mastodon á síðastliðnu ári.",
  "annual_report.announcement.title": "Ársuppgjörið {year} er komið",
  "annual_report.nav_item.badge": "Nýtt",
  "annual_report.shared_page.donate": "Styrkja",
  "annual_report.shared_page.footer": "{heart}-kveðjur frá Mastodon-teyminu",
  "annual_report.shared_page.footer_server_info": "{username} notar {domain}, einu af samfélögunum sem Mastodon drífur.",
  "annual_report.summary.archetype.booster.desc_public": "{name} var á höttunum eftir færslum til að endurbirta og hitti þannig í mark með að magna upp það sem aðrir voru að gera.",
  "annual_report.summary.archetype.booster.desc_self": "Þú varst á höttunum eftir færslum til að endurbirta og hittir þannig í mark með að magna upp það sem aðrir voru að gera.",
  "annual_report.summary.archetype.booster.name": "Veiðmaðurinn",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Við vitum að {name} var þarna úti, einhversstaðar, að njóta Mastodon á sínum eigin hljóðlátu forsendum.",
  "annual_report.summary.archetype.lurker.desc_self": "Við vitum að þú varst þarna úti, einhversstaðar, að njóta Mastodon á þínum eigin hljóðlátu forsendum.",
  "annual_report.summary.archetype.lurker.name": "Heimspekingurinn",
  "annual_report.summary.archetype.oracle.desc_public": "{name} útbjó fleiri færslur en svör og hélt þannig Mastodon fersku og vísandi til framtíðar.",
  "annual_report.summary.archetype.oracle.desc_self": "Þú útbjóst fleiri færslur en svör og hélst þannig Mastodon fersku og vísandi til framtíðar.",
  "annual_report.summary.archetype.oracle.name": "Völvan",
  "annual_report.summary.archetype.pollster.desc_public": "{name} útbjó fleiri kannanir en aðrar gerðir af færslum og ræktaði þannig forvitni á ökrum Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Þú útbjóst fleiri kannanir en aðrar gerðir af færslum og ræktaðir þannig forvitni á ökrum Mastodon.",
  "annual_report.summary.archetype.pollster.name": "Könnuðurinn",
  "annual_report.summary.archetype.replier.desc_public": "{name} svaraði oft færslum annara og frjóvgaði Mastodon með nýjum samræðum.",
  "annual_report.summary.archetype.replier.desc_self": "Þú svaraðir oft færslum annara og frjóvgaðir Mastodon með nýjum samræðum.",
  "annual_report.summary.archetype.replier.name": "Fiðrildið",
  "annual_report.summary.archetype.reveal": "Uppljóstra um erkitýpuna mína",
  "annual_report.summary.archetype.reveal_description": "Takk fyrir að vera hluti af Mastodon! Nú er tíminn til að sjá hvaða erkitýpu þú líktist árið {year}.",
  "annual_report.summary.archetype.title_public": "Erkitýpan fyrir {name}",
  "annual_report.summary.archetype.title_self": "Erkitýpan þín",
  "annual_report.summary.close": "Loka",
  "annual_report.summary.copy_link": "Afrita tengil",
  "annual_report.summary.followers.new_followers": "{count, plural, one {nýr fylgjandi} other {nýir fylgjendur}}",
  "annual_report.summary.highlighted_post.boost_count": "Þessi færsla var endurbirt {count, plural, one {einu sinni} other {# sinnum}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Þessi færsla var sett í eftirlæti {count, plural, one {einu sinni} other {# sinnum}}.",
  "annual_report.summary.highlighted_post.reply_count": "Þessi færsla fékk {count, plural, one {eitt svar} other {# svör}}.",
  "annual_report.summary.highlighted_post.title": "Vinsælasta færslan",
  "annual_report.summary.most_used_app.most_used_app": "mest notaða forrit",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "mest notaða myllumerki",
  "annual_report.summary.most_used_hashtag.used_count": "Þú hafðir þetta myllumerki með í {count, plural, one {einni færslu} other {# færslum}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} hafði þetta myllumerki með í {count, plural, one {einni færslu} other {# færslum}}.",
  "annual_report.summary.new_posts.new_posts": "nýjar færslur",
  "annual_report.summary.percentile.text": "<topLabel>Þetta setur þig á meðal</topLabel><percentage></percentage><bottomLabel>of {domain} virkustu notendanna.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Við förum ekkert að raupa um þetta.",
  "annual_report.summary.share_elsewhere": "Deila annarsstaðar",
  "annual_report.summary.share_message": "Ég er víst {archetype}-týpan!",
  "annual_report.summary.share_on_mastodon": "Deila á Mastodon",
  "attachments_list.unprocessed": "(óunnið)",
  "audio.hide": "Fela hljóð",
  "block_modal.no_collections": "Hvorugur ykkar getur bætt hinum í söfn. Þú verður sjálfkrafa fjarlægð/ur úr fyrirliggjandi söfnum hins, ef við á.",
  "block_modal.remote_users_caveat": "Við munum biðja {domain} netþjóninn um að virða ákvörðun þína. Hitt er svo annað mál hvort hann fari eftir þessu, ekki er hægt að tryggja eftirfylgni því sumir netþjónar meðhöndla útilokanir á sinn hátt. Opinberar færslur gætu verið sýnilegar notendum sem ekki eru skráðir inn.",
  "block_modal.show_less": "Sýna minna",
  "block_modal.show_more": "Sýna meira",
  "block_modal.they_cant_mention": "Þið getið ekki minnst á, fylgst með eða vitnað í hvorn annan.",
  "block_modal.they_cant_see_posts": "Viðkomandi geta ekki séð efnið þitt og þú ekki þeirra.",
  "block_modal.they_will_know": "Viðkomandi geta séð að þeir eru útilokaðir.",
  "block_modal.title": "Útiloka notanda?",
  "block_modal.you_wont_see_mentions": "Þú munt ekki sjá færslur frá öðrum sem minnast á viðkomandi aðila.",
  "boost_modal.combo": "Þú getur ýtt á {combo} til að sleppa þessu næst",
  "boost_modal.reblog": "Endurbirta færslu?",
  "boost_modal.undo_reblog": "Taka færslu úr endurbirtingu?",
  "bundle_column_error.copy_stacktrace": "Afrita villuskýrslu",
  "bundle_column_error.error.body": "Umbeðna síðau var ekki hægt að myndgera. Það gæti verið vegna villu í kóðanum okkar eða vandamáls með samhæfni vafra.",
  "bundle_column_error.error.title": "Ó-nei!",
  "bundle_column_error.network.body": "Villa kom upp við að hlaða inn þessari síðu. Þetta gæti stafað af tímabundnum vandamálum með internettenginguna þína eða þennan netþjón.",
  "bundle_column_error.network.title": "Villa í netkerfi",
  "bundle_column_error.retry": "Reyna aftur",
  "bundle_column_error.return": "Fara til baka á upphafssíðu",
  "bundle_column_error.routing.body": "Umbeðin síða fannst ekki. Ertu viss um að slóðin í vistfangastikunni sé rétt?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Loka",
  "bundle_modal_error.message": "Eitthvað fór úrskeiðis við að hlaða inn þessum skjá.",
  "bundle_modal_error.retry": "Reyndu aftur",
  "callout.dismiss": "Vísa frá",
  "carousel.current": "<sr>Skyggna</sr> {current, number} / {max, number}",
  "carousel.slide": "Skyggna {current, number} af {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} stafir sem mælt er með",
  "character_counter.required": "{currentLength}/{maxLength} stafir",
  "closed_registrations.other_server_instructions": "Þar sem Mastodon er ekki miðstýrt, þá getur þú búið til aðgang á öðrum þjóni, en samt haft samskipti við þennan.",
  "closed_registrations_modal.description": "Að búa til aðgang á {domain} er ekki mögulegt eins og er, en vinsamlegast hafðu í huga að þú þarft ekki aðgang sérstaklega á {domain} til að nota Mastodon.",
  "closed_registrations_modal.find_another_server": "Finna annan netþjón",
  "closed_registrations_modal.preamble": "Mastodon er ekki miðstýrt, svo það skiptir ekki máli hvar þú býrð til aðgang; þú munt get fylgt eftir og haft samskipti við hvern sem er á þessum þjóni. Þú getur jafnvel hýst þinn eigin Mastodon þjón!",
  "closed_registrations_modal.title": "Að nýskrá sig á Mastodon",
  "collection.share_modal.share_link_label": "Deila tengli",
  "collection.share_modal.share_via_post": "Birta á Mastodon",
  "collection.share_modal.share_via_system": "Deila með…",
  "collection.share_modal.title": "Deila safni",
  "collection.share_modal.title_new": "Deildu nýja safninu þínu!",
  "collection.share_template_other": "Kíktu á þetta áhugaverða safn: {link}",
  "collection.share_template_own": "Kíktu á nýja safnið mitt: {link}",
  "collections.account_count": "{count, plural, one {# aðgangur} other {# aðgangar}}",
  "collections.accounts.empty_description": "Bættu við allt að {count} aðgöngum",
  "collections.accounts.empty_editor_title": "Enginn er enn í þessu safni",
  "collections.accounts.empty_title": "Þetta safn er tómt",
  "collections.block_collection_owner": "Útiloka notandaaðgang",
  "collections.by_account": "frá {account_handle}",
  "collections.collection_description": "Lýsing",
  "collections.collection_language": "Tungumál",
  "collections.collection_language_none": "Ekkert",
  "collections.collection_name": "Nafn",
  "collections.collection_topic": "Umfjöllunarefni",
  "collections.confirm_account_removal": "Ertu viss um að þú viljir fjarlægja þennan aðgang úr þessu safni?",
  "collections.content_warning": "Viðvörun vegna efnis",
  "collections.continue": "Halda áfram",
  "collections.copy_link": "Afrita tengil",
  "collections.copy_link_confirmation": "Afritaði tengil á safn á klippispjald",
  "collections.create.accounts_title": "Hvern vilt þú gera áberandi í þessu safni?",
  "collections.create.basic_details_title": "Grunnupplýsingar",
  "collections.create.steps": "Skref {step}/{total}",
  "collections.create_collection": "Búa til safn",
  "collections.delete_collection": "Eyða safni",
  "collections.description_length_hint": "100 stafa takmörk",
  "collections.detail.author_added_you_on_date": "{author} bætti þér við þann {date}",
  "collections.detail.loading": "Hleð inn safni…",
  "collections.detail.revoke_inclusion": "Fjarlægja mig",
  "collections.detail.sensitive_content": "Viðkvæmt efni",
  "collections.detail.sensitive_note": "Þetta safn inniheldur aðganga og efni sem sumir notendur gætu verið viðkvæmir fyrir.",
  "collections.detail.share": "Deila þessu safni",
  "collections.detail.you_are_in_this_collection": "Þú kemur fyrir í þessu safni",
  "collections.edit_details": "Breyta ítarupplýsingum",
  "collections.error_loading_collections": "Villa kom upp þegar reynt var að hlaða inn þessum söfnum.",
  "collections.hidden_accounts_description": "Þú hefur lokað á eða þaggað niður í {count, plural, one {þessum notanda} other {þessum notendum}}",
  "collections.hidden_accounts_link": "{count, plural, one {# falinn aðgangur} other {# faldir aðgangar}}",
  "collections.hints.accounts_counter": "{count}/{max} aðgöngum",
  "collections.last_updated_at": "Síðast uppfært: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# safn} other {# söfn}}",
  "collections.list.created_by_author": "Útbúið af {name}",
  "collections.list.created_by_you": "Útbúið af þér",
  "collections.list.featuring_you": "Innifelur þig",
  "collections.manage_accounts": "Sýsla með notandaaðganga",
  "collections.mark_as_sensitive": "Merkja sem viðkvæmt",
  "collections.mark_as_sensitive_hint": "Felur lýsingu safnsins og notendur á bakvið aðvörun vegna efnis. Nafn safnsins verður áfram sýnilegt.",
  "collections.maximum_collection_count_description": "Netþjónninn þinn leyfir gerð á allt að {count} söfnum.",
  "collections.maximum_collection_count_reached": "Þú hefur útbúið leyfilegan hámarksfjölda safna",
  "collections.name_length_hint": "40 stafa takmörk",
  "collections.new_collection": "Nýtt safn",
  "collections.pending_accounts.message": "Aðgangar geta litið út fyrir að vera í biðstöðu á meðan beðið er eftir svari frá þeim eða netþjóninum þar sem þeir eru hýstir. Einungis þú getur séð aðganga sem eru í bið.",
  "collections.pending_accounts.title": "Af hverju er ég að sjá aðganga sem bíða?",
  "collections.remove_account": "Fjarlægja",
  "collections.report_collection": "Tilkynna þetta safn",
  "collections.revoke_collection_inclusion": "Fjarlægja mig úr þessu safni",
  "collections.revoke_inclusion.confirmation": "Þú varst fjarlægð/ur úr \"{collection}\"",
  "collections.revoke_inclusion.error": "Upp kom villa, reyndu aftur síðar.",
  "collections.search_accounts_label": "Leitaðu að aðgangi til að bæta við",
  "collections.search_accounts_max_reached": "Þú hefur þegar bætt við leyfilegum hámarksfjölda aðganga",
  "collections.sensitive": "Viðkvæmt",
  "collections.share_short": "Deila",
  "collections.suggestions.can_not_add": "Er ekki hægt að bæta við",
  "collections.suggestions.can_not_add_desc": "Þessir aðgangar gætu hafa skráð sig úr almennri birtingu eða gætu verið á netþjónum sem ekki styðja söfn.",
  "collections.suggestions.must_follow": "Verður fyrst að fylgja",
  "collections.suggestions.must_follow_desc": "Þessir aðgangar yfirfara allar beiðnir um að fylgja þeim. Fylgjendur geta bætt þeim í söfn.",
  "collections.topic_hint": "Bættu við myllumerki sem hjálpar öðrum að skilja aðalefni þessa safns.",
  "collections.topic_special_chars_hint": "Sérstafir verða fjarlægðir við vistun",
  "collections.unlisted_collections_description": "Þessi birtast ekki öðrum á notandasíðunni þinni. Þeir sem eru með tengil á þau geta séð þau.",
  "collections.unlisted_collections_with_count": "Óskráð söfn ({count})",
  "collections.view_collection": "Skoða safn",
  "collections.visibility_public": "Opinbert",
  "collections.visibility_public_hint": "Hægt að finna í leitarniðurstöðum og öðrum þeim þáttum þar sem meðmæli birtast.",
  "collections.visibility_title": "Sýnileiki",
  "collections.visibility_unlisted": "Óskráð",
  "collections.visibility_unlisted_hint": "Sýnilegt hverjum þeim sem eru með tengil. Falið í leitarniðurstöðum og meðmælum.",
  "column.about": "Um hugbúnaðinn",
  "column.blocks": "Útilokaðir notendur",
  "column.bookmarks": "Bókamerki",
  "column.community": "Staðvær tímalína",
  "column.create_list": "Búa til lista",
  "column.direct": "Einkaspjall",
  "column.directory": "Skoða notendasnið",
  "column.domain_blocks": "Útilokuð lén",
  "column.edit_list": "Breyta lista",
  "column.favourites": "Eftirlæti",
  "column.firehose": "Bein streymi",
  "column.firehose_local": "Beint streymi á þessum netþjóni",
  "column.firehose_singular": "Beint streymi",
  "column.follow_requests": "Beiðnir um að fylgjast með",
  "column.home": "Heim",
  "column.list_members": "Sýsla með meðlimi listans",
  "column.lists": "Listar",
  "column.mutes": "Þaggaðir notendur",
  "column.notifications": "Tilkynningar",
  "column.other_collections": "Söfn frá {name}",
  "column.pins": "Festar færslur",
  "column.public": "Sameiginleg tímalína",
  "column.your_collections": "Söfnin þín",
  "column_back_button.label": "Til baka",
  "column_header.hide_settings": "Fela stillingar",
  "column_header.moveLeft_settings": "Færa dálk til vinstri",
  "column_header.moveRight_settings": "Færa dálk til hægri",
  "column_header.pin": "Festa",
  "column_header.show_settings": "Birta stillingar",
  "column_header.unpin": "Losa",
  "column_search.cancel": "Hætta við",
  "combobox.close_results": "Loka niðurstöðum",
  "combobox.loading": "Hleð inn",
  "combobox.no_results_found": "Engar niðurstöður með þessari leit",
  "combobox.open_results": "Opna niðurstöður",
  "combobox.results_available": "{count, plural, one {# tillaga} other {# tillögur}} í boði. Notaðu upp- og niður- örvalyklana til að fara á milli. Ýttu á Enter til að velja.",
  "community.column_settings.local_only": "Einungis staðvært",
  "community.column_settings.media_only": "Einungis myndskrár",
  "community.column_settings.remote_only": "Einungis fjartengt",
  "compose.error.blank_post": "Færsla má ekki vera auð.",
  "compose.language.change": "Skipta um tungumál",
  "compose.language.search": "Leita að tungumálum...",
  "compose.published.body": "Færsla birt.",
  "compose.published.open": "Opna",
  "compose.saved.body": "Færsla vistuð.",
  "compose_form.direct_message_warning_learn_more": "Kanna nánar",
  "compose_form.encryption_warning": "Færslur á Mastodon eru ekki enda-í-enda dulritaðar. Ekki deila viðkvæmum upplýsingum á Mastodon.",
  "compose_form.hashtag_warning": "Þessi færsla verður ekki talin með undir nokkru myllumerki þar sem það er ekki opinbert. Einungis er hægt að leita að opinberum færslum eftir myllumerkjum.",
  "compose_form.lock_disclaimer": "Aðgangurinn þinn er ekki {locked}. Hver sem er getur fylgst með þér til að sjá þær færslur sem einungis eru til fylgjenda þinna.",
  "compose_form.lock_disclaimer.lock": "læstur",
  "compose_form.placeholder": "Hvað liggur þér á hjarta?",
  "compose_form.poll.duration": "Tímalengd könnunar",
  "compose_form.poll.multiple": "Margir valkostir",
  "compose_form.poll.option_placeholder": "Valkostur {number}",
  "compose_form.poll.single": "Eitt val",
  "compose_form.poll.switch_to_multiple": "Breyta könnun svo hægt sé að hafa marga valkosti",
  "compose_form.poll.switch_to_single": "Breyta könnun svo hægt sé að hafa einn stakan valkost",
  "compose_form.poll.type": "Stíll",
  "compose_form.publish": "Birta",
  "compose_form.reply": "Svara",
  "compose_form.save_changes": "Uppfæra",
  "compose_form.spoiler.marked": "Fjarlægja aðvörun vegna efnis",
  "compose_form.spoiler.unmarked": "Bæta við aðvörun vegna efnis",
  "compose_form.spoiler_placeholder": "Aðvörun vegna efnis (valkvætt)",
  "confirmation_modal.cancel": "Hætta við",
  "confirmations.block.confirm": "Útiloka",
  "confirmations.delete.confirm": "Eyða",
  "confirmations.delete.message": "Ertu viss um að þú viljir eyða þessari færslu?",
  "confirmations.delete.title": "Eyða færslu?",
  "confirmations.delete_collection.confirm": "Eyða",
  "confirmations.delete_collection.message": "Þessa aðgerð er ekki hægt að afturkalla.",
  "confirmations.delete_collection.title": "Eyða “{name}\"?",
  "confirmations.delete_list.confirm": "Eyða",
  "confirmations.delete_list.message": "Ertu viss um að þú viljir eyða þessum lista endanlega?",
  "confirmations.delete_list.title": "Eyða lista?",
  "confirmations.discard_draft.confirm": "Henda og halda áfram",
  "confirmations.discard_draft.edit.cancel": "Halda áfram að breyta",
  "confirmations.discard_draft.edit.message": "Ef þú heldur áfram verður öllum breytingum sem þú hefur gert á færslunni verða hent.",
  "confirmations.discard_draft.edit.title": "Henda breytingum á færslunni þinni?",
  "confirmations.discard_draft.post.cancel": "Halda áfram með drög",
  "confirmations.discard_draft.post.message": "Ef þú heldur áfram verður færslunni sem þú ert að skrifA hent.",
  "confirmations.discard_draft.post.title": "Henda drögum að færslunni þinni?",
  "confirmations.discard_edit_media.confirm": "Henda",
  "confirmations.discard_edit_media.message": "Þú ert með óvistaðar breytingar á lýsingu myndefnis eða forskoðunar, henda þeim samt?",
  "confirmations.follow_to_list.confirm": "Fylgja og bæta á lista",
  "confirmations.follow_to_list.message": "Þú þarft að fylgja {name} til að bæta viðkomandi á lista.",
  "confirmations.follow_to_list.title": "Fylgja notanda?",
  "confirmations.hide_featured_tab.confirm": "Fela flipa",
  "confirmations.hide_featured_tab.intro": "Þú getur breytt þessu hvenær sem er í <i>Breyta notandasniði > Stillingar notandasniðsflipa</i>.",
  "confirmations.hide_featured_tab.message": "Þetta mun fela flipann fyrir notendum á {serverName} og öðrum netþjónum sem nota nýjustu útgáfuna af Mastodon. Birting í öðrum viðmótum gæti verið á ýmsan máta.",
  "confirmations.hide_featured_tab.title": "Fela \"Með aukið vægi\" flipann?",
  "confirmations.logout.confirm": "Skrá út",
  "confirmations.logout.message": "Ertu viss um að þú viljir skrá þig út?",
  "confirmations.logout.title": "Skrá út?",
  "confirmations.missing_alt_text.confirm": "Bæta við hjálpartexta",
  "confirmations.missing_alt_text.message": "Færslan þín inniheldur myndefni án ALT-hjálpartexta. Ef þú bætir við lýsingu á myndefninu gerir það efnið þitt aðgengilegt fyrir fleira fólk.",
  "confirmations.missing_alt_text.secondary": "Birta samt",
  "confirmations.missing_alt_text.title": "Bæta við hjálpartexta?",
  "confirmations.mute.confirm": "Þagga",
  "confirmations.private_quote_notify.cancel": "Til baka í breytingar",
  "confirmations.private_quote_notify.confirm": "Birta færslu",
  "confirmations.private_quote_notify.do_not_show_again": "Ekki birta þessi skilaboð aftur",
  "confirmations.private_quote_notify.message": "Sá sem vitnað er í og aðrir sem minnst er á verða látin vita og munu geta skoðað færsluna þína, jafnvel þótt viðkomandi fylgist ekki með þér.",
  "confirmations.private_quote_notify.title": "Deila með fylgjendum og þeim sem minnst er á?",
  "confirmations.quiet_post_quote_info.dismiss": "Ekki minna mig aftur á þetta",
  "confirmations.quiet_post_quote_info.got_it": "Náði því",
  "confirmations.quiet_post_quote_info.message": "Þegar þú vitnar í hljóðláta opinbera færslu, verður færslan þín ekki birt á vinsældatímalínum.",
  "confirmations.quiet_post_quote_info.title": "Vitnað í hljóðlátar opinberar færslur",
  "confirmations.redraft.confirm": "Eyða og endurvinna drög",
  "confirmations.redraft.message": "Ertu viss um að þú viljir eyða þessari færslu og enduvinna drögin? Eftirlæti og endurbirtingar munu glatast og svör við upprunalegu færslunni munu verða munaðarlaus.",
  "confirmations.redraft.title": "Eyða og byrja ný drög að færslu?",
  "confirmations.remove_from_followers.confirm": "Fjarlægja fylgjanda",
  "confirmations.remove_from_followers.message": "{name} mun hætta að fylgja þér. Ertu viss um að þú viljir halda áfram?",
  "confirmations.remove_from_followers.title": "Fjarlægja fylgjanda?",
  "confirmations.revoke_collection_inclusion.confirm": "Fjarlægja mig",
  "confirmations.revoke_collection_inclusion.message": "Þessi aðgerð er varanleg og umsjónaraðili safnsins mun ekki geta bætt þér aftur við síðar.",
  "confirmations.revoke_collection_inclusion.title": "Á að fjarlægja þig úr þessu safni?",
  "confirmations.revoke_quote.confirm": "Fjarlægja færslu",
  "confirmations.revoke_quote.message": "Þessa aðgerð er ekki hægt að afturkalla.",
  "confirmations.revoke_quote.title": "Fjarlægja færslu?",
  "confirmations.unblock.confirm": "Aflétta útilokun",
  "confirmations.unblock.title": "Aflétta útilokun á {name}?",
  "confirmations.unfollow.confirm": "Hætta að fylgja",
  "confirmations.unfollow.title": "Hætta að fylgja {name}?",
  "confirmations.withdraw_request.confirm": "Taka beiðni til baka",
  "confirmations.withdraw_request.title": "Taka aftur beiðni um að fylgja {name}?",
  "content_warning.hide": "Fela færslu",
  "content_warning.show": "Birta samt",
  "content_warning.show_more": "Sýna meira",
  "content_warning.show_short": "Sýna",
  "conversation.delete": "Eyða samtali",
  "conversation.mark_as_read": "Merkja sem lesið",
  "conversation.open": "Skoða samtal",
  "conversation.with": "Við {names}",
  "copy_icon_button.copied": "Afritað á klippispjald",
  "copy_icon_button.copy_this_text": "Afrita tengil á klippispjald",
  "copypaste.copied": "Afritað",
  "copypaste.copy_to_clipboard": "Afrita á klippispjald",
  "directory.federated": "Frá samtengdum vefþjónum",
  "directory.local": "Einungis frá {domain}",
  "directory.new_arrivals": "Nýkomnir",
  "directory.recently_active": "Nýleg virkni",
  "disabled_account_banner.account_settings": "Stillingar notandaaðgangs",
  "disabled_account_banner.text": "Aðgangurinn þinn {disabledAccount} er óvirkur í augnablikinu.",
  "dismissable_banner.community_timeline": "Þetta eru nýjustu opinberu færslurnar frá fólki sem er hýst á {domain}.",
  "dismissable_banner.dismiss": "Hunsa",
  "dismissable_banner.public_timeline": "Þetta eru nýjustu opinberu færslurnar frá fólki á samfélagsnetinu sem fólk á {domain} fylgjast með.",
  "domain_block_modal.block": "Útiloka netþjón",
  "domain_block_modal.block_account_instead": "Útiloka {name} í staðinn",
  "domain_block_modal.they_can_interact_with_old_posts": "Fólk frá þessum netþjóni getur sýslað með eldri færslur þínar.",
  "domain_block_modal.they_cant_follow": "Enginn frá þessum netþjóni getur fylgst með þér.",
  "domain_block_modal.they_wont_know": "Viðkomandi mun ekki vita að hann hafi verið útilokaður.",
  "domain_block_modal.title": "Útiloka lén?",
  "domain_block_modal.you_will_lose_num_followers": "Þú munt missa {followersCount, plural, one {{followersCountDisplay} fylgjanda} other {{followersCountDisplay} fylgjendur}} og {followingCount, plural, one {{followingCountDisplay} aðila sem þú fylgist með} other {{followingCountDisplay} aðila sem þú fylgist með}}.",
  "domain_block_modal.you_will_lose_relationships": "Þú munt missa alla fylgjendur og þá sem þú fylgist með á þessum netþjóni.",
  "domain_block_modal.you_wont_see_posts": "Þú munt ekki sjá neinar færslur eða tilkynningar frá notendum á þessum netþjóni.",
  "domain_pill.activitypub_lets_connect": "Það gerir þér kleift að tengjast og eiga í samskiptum við fólk, ekki bara á Mastodon, heldur einnig á mörgum öðrum mismunandi samfélagsmiðlum.",
  "domain_pill.activitypub_like_language": "ActivityPub er eins og tungumál sem Mastodon notar til að tala við önnur samfélagsnet.",
  "domain_pill.server": "Netþjónn",
  "domain_pill.their_handle": "Kennislóðin þeirra:",
  "domain_pill.their_server": "Stafrænt heimili viðkomandi, þar sem allar færslur hans eru hýstar.",
  "domain_pill.their_username": "Sértækt auðkenni viðkomandi á netþjóni hans. Það er mögulegt að finna notendur með sama notandanafn á mismunandi netþjónum.",
  "domain_pill.username": "Notandanafn",
  "domain_pill.whats_in_a_handle": "Hvað er í kennislóð (handle)?",
  "domain_pill.who_they_are": "Vegna þess að kennislóðir segja hver einhver sé og hvar hann sé að finna, getur þú átt í samskiptum við fólk í gegnum samfélagsvef sem knúinn er af <button>ActivityPub-samhæfðum kerfum</button>.",
  "domain_pill.who_you_are": "Vegna þess að kennislóðin þín segir hver þú sért og hvar þig sé að finna, getur fólk átt í samskiptum við þig í gegnum samfélagsvef sem knúinn er af <button>ActivityPub-samhæfðum kerfum</button>.",
  "domain_pill.your_handle": "Kennislóðin þín:",
  "domain_pill.your_server": "Stafrænt heimili þitt, þar sem allar færslur þínar eru hýstar. Kanntu ekki við þennan netþjón? Þú getur flutt þig á milli netþjóna hvenær sem er og tekið með þér alla fylgjendurna þína.",
  "domain_pill.your_username": "Sértækt auðkenni þitt á þessum netþjóni. Það er mögulegt að finna notendur með sama notandanafn á mismunandi netþjónum.",
  "dropdown.empty": "Veldu valkost",
  "email_subscriptions.email": "Tölvupóstur",
  "email_subscriptions.form.action": "Gerast áskrifandi",
  "email_subscriptions.form.bottom": "Fáðu færslur í tölvupósti án þess að útbúa Mastodon-aðgang. Segðu upp áskrift hvenær sem er. Nánari upplýsingar má finna í <a>Meðferð persónuupplýsinga</a>.",
  "email_subscriptions.form.title": "Skráðu þig í áskrift í tölvupósti að færslum frá {name}",
  "email_subscriptions.submitted.lead": "Athugaðu hvort þér hafi borist tölvupóstur til að ljúka áskriftarferlinu.",
  "email_subscriptions.submitted.title": "Eitt skref í viðbót",
  "email_subscriptions.validation.email.blocked": "Útilokuð póstþjónusta",
  "email_subscriptions.validation.email.invalid": "Ógilt tölvupóstfang",
  "embed.instructions": "Felldu þessa færslu inn í vefsvæðið þitt með því að afrita kóðann hér fyrir neðan.",
  "embed.preview": "Svona mun þetta líta út:",
  "emoji_button.activity": "Athafnir",
  "emoji_button.clear": "Hreinsa",
  "emoji_button.custom": "Sérsniðin",
  "emoji_button.flags": "Flögg",
  "emoji_button.food": "Matur og drykkur",
  "emoji_button.label": "Setja inn lyndistákn",
  "emoji_button.nature": "Náttúra",
  "emoji_button.not_found": "Engin samsvarandi lyndistákn fundust",
  "emoji_button.objects": "Hlutir",
  "emoji_button.people": "Fólk",
  "emoji_button.recent": "Oft notuð",
  "emoji_button.search": "Leita...",
  "emoji_button.search_results": "Leitarniðurstöður",
  "emoji_button.symbols": "Tákn",
  "emoji_button.travel": "Ferðalög og staðir",
  "empty_column.account_featured.other": "{acct} hefur enn ekki gefið neinu aukið vægi.",
  "empty_column.account_featured_self.no_collections_button": "Búa til safn",
  "empty_column.account_featured_self.no_collections_hide_tab": "Fela frekar þennan flipa",
  "empty_column.account_featured_self.pre_collections": "Kynntu þér hvað séu söfn",
  "empty_column.account_featured_self.pre_collections_desc": "Söfn (sem koma fram í Mastodon 4.6) gera þér kleift að búa til þina eigin ritstýrðu lista yfir þá aðganga sem þú vilt mæla með við aðra.",
  "empty_column.account_featured_self.showcase_accounts": "Kynntu eftirlætisaðgangana þína",
  "empty_column.account_featured_self.showcase_accounts_desc": "Söfn eru ritstýrðir listar yfir aðganga til að hjálpa öðrum að uppgötva fleira á samfélagsnetinu.",
  "empty_column.account_featured_unknown.other": "Þessi notandi hefur enn ekki sett neitt með meira vægi.",
  "empty_column.account_hides_collections": "Notandinn hefur valið að gera ekki tiltækar þessar upplýsingar",
  "empty_column.account_suspended": "Notandaaðgangur í frysti",
  "empty_column.account_timeline": "Engar færslur hér!",
  "empty_column.account_unavailable": "Notandasnið ekki tiltækt",
  "empty_column.blocks": "Þú hefur ekki ennþá útilokað neina notendur.",
  "empty_column.bookmarked_statuses": "Þú ert ekki ennþá með neinar bókamerktar færslur. Þegar þú bókamerkir færslu, mun það birtast hér.",
  "empty_column.collections.featured_in": "Þér hefur enn ekki verið bætt við nein söfn.",
  "empty_column.community": "Staðværa tímalínan er tóm. Skrifaðu eitthvað opinberlega til að láta boltann fara að rúlla!",
  "empty_column.direct": "Þú ert ekki ennþá með neitt einkaspjall við neinn. Þegar þú sendir eða tekur við slíku, mun það birtast hér.",
  "empty_column.disabled_feed": "Þetta streymi hefur verið gert óvirkt af stjórnendum netþjónis þíns.",
  "empty_column.domain_blocks": "Það eru ennþá engin útilokuð lén.",
  "empty_column.explore_statuses": "Ekkert er á uppleið í augnablikinu. Athugaðu aftur síðar!",
  "empty_column.favourited_statuses": "Þú ert ekki ennþá með neinar eftirlætisfærslur. Þegar þú setur færslu í eftirlæti, munu þau birtast hér.",
  "empty_column.favourites": "Enginn hefur ennþá sett þessa færslu í eftirlæti. Þegar einhver gerir það, mun það birtast hér.",
  "empty_column.follow_requests": "Þú átt ennþá engar beiðnir um að fylgja þér. Þegar þú færð slíkar beiðnir, munu þær birtast hér.",
  "empty_column.followed_tags": "Þú ert ekki ennþá farin/n að fylgjast með myllumerkjum. Þegar þú gerir það, munu þau birtast hér.",
  "empty_column.hashtag": "Það er ekkert ennþá undir þessu myllumerki.",
  "empty_column.home": "Heimatímalínan þín er tóm! Fylgstu með fleira fólki til að fylla hana. {suggestions}",
  "empty_column.list": "Það er ennþá ekki neitt á þessum lista. Þegar meðlimir á listanum senda inn nýjar færslur, munu þær birtast hér.",
  "empty_column.mutes": "Þú hefur ekki þaggað niður í neinum notendum ennþá.",
  "empty_column.notification_requests": "Allt hreint! Það er ekkert hér. Þegar þú færð nýjar tilkynningar, munu þær birtast hér í samræmi við stillingarnar þínar.",
  "empty_column.notifications": "Þú ert ekki ennþá með neinar tilkynningar. Vertu í samskiptum við aðra til að umræður fari af stað.",
  "empty_column.public": "Það er ekkert hér! Skrifaðu eitthvað opinberlega, eða fylgstu með notendum á öðrum netþjónum til að fylla upp í þetta",
  "empty_state.no_results": "Engar niðurstöður",
  "error.no_hashtag_feed_access": "Skráðu þig inn eða stofnaðu aðgang til að skoða og fylgjast með þessu myllumerki.",
  "error.unexpected_crash.explanation": "Vegna villu í kóðanum okkar eða samhæfnivandamála í vafra er ekki hægt að birta þessa síðu svo vel sé.",
  "error.unexpected_crash.explanation_addons": "Ekki er hægt að birta þessa síðu rétt. Þetta er líklega af völdum forritsviðbótar í vafranum eða sjálfvirkra þýðainaverkfæra.",
  "error.unexpected_crash.next_steps": "Prófaðu að endurlesa síðuna. Ef það hjálpar ekki til, má samt vera að þú getir notað Mastodon í gegnum annan vafra eða forrit.",
  "error.unexpected_crash.next_steps_addons": "Prófaðu að gera þau óvirk og svo endurlesa síðuna. Ef það hjálpar ekki til, má samt vera að þú getir notað Mastodon í gegnum annan vafra eða forrit.",
  "errors.unexpected_crash.copy_stacktrace": "Afrita rakningarupplýsingar (stacktrace) á klippispjald",
  "errors.unexpected_crash.report_issue": "Tilkynna vandamál",
  "explore.suggested_follows": "Fólk",
  "explore.title": "Vinsælt",
  "explore.trending_links": "Fréttir",
  "explore.trending_statuses": "Færslur",
  "explore.trending_tags": "Myllumerki",
  "featured_carousel.current": "<sr>Færsla</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Fest færsla} other {Festar færslur}}",
  "featured_carousel.slide": "Færsla {current, number} af {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Að undanförnu hefurðu skrifað um {items}. Ætti að bæta þessu við sem myllumerkjum með aukið vægi?",
  "featured_tags.suggestions.add": "Bæta við",
  "featured_tags.suggestions.added": "Sýslaðu með þau myllumerki þín sem eru með með aukið vægi með því að fara í <link>Breyta notandasniði > Myllumerki með aukið vægi</link>.",
  "featured_tags.suggestions.dismiss": "Nei takk",
  "filter_modal.added.context_mismatch_explanation": "Þessi síuflokkur á ekki við í því samhengi sem aðgangur þinn að þessari færslu felur í sér. Ef þú vilt að færslan sé einnig síuð í þessu samhengi, þá þarftu að breyta síunni.",
  "filter_modal.added.context_mismatch_title": "Misræmi í samhengi!",
  "filter_modal.added.expired_explanation": "Þessi síuflokkur er útrunninn, þú þarft að breyta gidistímanum svo hann geti átt við.",
  "filter_modal.added.expired_title": "Útrunnin sía!",
  "filter_modal.added.review_and_configure": "Til að yfirfara og stilla frekar þennan síuflokk, ættirðu að fara í {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Síustillingar",
  "filter_modal.added.settings_link": "stillingasíða",
  "filter_modal.added.short_explanation": "Þessari færslu hefur verið bætt í eftirfarandi síuflokk: {title}.",
  "filter_modal.added.title": "Síu bætt við!",
  "filter_modal.select_filter.context_mismatch": "á ekki við í þessu samhengi",
  "filter_modal.select_filter.expired": "útrunnið",
  "filter_modal.select_filter.prompt_new": "Nýr flokkur: {name}",
  "filter_modal.select_filter.search": "Leita eða búa til",
  "filter_modal.select_filter.subtitle": "Notaðu fyrirliggjandi flokk eða útbúðu nýjan",
  "filter_modal.select_filter.title": "Sía þessa færslu",
  "filter_modal.title.status": "Sía færslu",
  "filter_warning.matches_filter": "Samsvarar síunni “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "Frá {count, plural, =0 {engum} one {einum aðila} other {# manns}} sem þú gætir þekkt",
  "filtered_notifications_banner.title": "Síaðar tilkynningar",
  "firehose.all": "Allt",
  "firehose.local": "þessum netþjóni",
  "firehose.remote": "öðrum netþjónum",
  "follow_request.authorize": "Heimila",
  "follow_request.reject": "Hafna",
  "follow_requests.unlocked_explanation": "Jafnvel þótt aðgangurinn þinn sé ekki læstur, hafa umsjónarmenn {domain} ímyndað sér að þú gætir viljað yfirfara handvirkt fylgjendabeiðnir frá þessum notendum.",
  "follow_suggestions.curated_suggestion": "Úrval starfsfólks",
  "follow_suggestions.dismiss": "Ekki birta þetta aftur",
  "follow_suggestions.featured_longer": "Handvalið af {domain}-teyminu",
  "follow_suggestions.friends_of_friends_longer": "Vinsælt hjá fólki sem þú fylgist með",
  "follow_suggestions.hints.featured": "Þetta notandasnið hefur verið handvalið af {domain}-teyminu.",
  "follow_suggestions.hints.friends_of_friends": "Þetta notandasnið er vinsælt hjá fólki sem þú fylgist með.",
  "follow_suggestions.hints.most_followed": "Þetta notandasnið er eitt af þeim sem mest er fylgst með á {domain}.",
  "follow_suggestions.hints.most_interactions": "Þetta notandasnið hefur vakið mikla athygli að undanförnu á {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Þetta notandasnið er líkt þeim sniðum sem þú hefur valið að fylgjast með að undanförnu.",
  "follow_suggestions.personalized_suggestion": "Persónuaðlöguð tillaga",
  "follow_suggestions.popular_suggestion": "Vinsæl tillaga",
  "follow_suggestions.popular_suggestion_longer": "Vinsælt á {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Svipar til notenda sem þú hefur nýlega farið að fylgjast með",
  "follow_suggestions.view_all": "Skoða allt",
  "follow_suggestions.who_to_follow": "Hverjum á að fylgjast með",
  "followed_tags": "Vöktuð myllumerki",
  "followers.hide_other_followers": "Þessi notandi hefur valið að gera ekki sýnilega aðra fylgjendur sína",
  "followers.title": "Fylgist með {name}",
  "following.hide_other_following": "Þessi notandi hefur valið að gera ekki sýnilega aðra þá sem þeir fylgjast með",
  "following.title": "Fylgt af {name}",
  "footer.about": "Nánari upplýsingar",
  "footer.about_mastodon": "Um Mastodon",
  "footer.about_server": "Um {domain}",
  "footer.about_this_server": "Nánari upplýsingar",
  "footer.directory": "Notandasniðamappa",
  "footer.get_app": "Ná í forritið",
  "footer.keyboard_shortcuts": "Flýtileiðir á lyklaborði",
  "footer.privacy_policy": "Meðferð persónuupplýsinga",
  "footer.source_code": "Skoða frumkóða",
  "footer.status": "Staða",
  "footer.terms_of_service": "Þjónustuskilmálar",
  "form_error.blank": "Reitur má ekki vera auður.",
  "form_field.optional": "(valfrjálst)",
  "generic.saved": "Vistað",
  "getting_started.heading": "Komast í gang",
  "hashtag.admin_moderation": "Opna umsjónarviðmót fyrir #{name}",
  "hashtag.browse": "Skoða færslur með #{hashtag}",
  "hashtag.browse_from_account": "Skoða færslur frá @{name} í #{hashtag}",
  "hashtag.column_header.tag_mode.all": "og {additional}",
  "hashtag.column_header.tag_mode.any": "eða {additional}",
  "hashtag.column_header.tag_mode.none": "án {additional}",
  "hashtag.column_settings.select.no_options_message": "Engar tillögur fundust",
  "hashtag.column_settings.select.placeholder": "Settu inn myllumerki…",
  "hashtag.column_settings.tag_mode.all": "Allt þetta",
  "hashtag.column_settings.tag_mode.any": "Hvað sem er af þessu",
  "hashtag.column_settings.tag_mode.none": "Ekkert af þessu",
  "hashtag.column_settings.tag_toggle": "Taka með viðbótarmerki fyrir þennan dálk",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} þátttakandi} other {{counter} þátttakendur}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} færsla} other {{counter} færslur}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} færsla} other {{counter} færslur}} í dag",
  "hashtag.feature": "Birta á notandasniði",
  "hashtag.follow": "Fylgjast með myllumerki",
  "hashtag.mute": "Þagga #{hashtag}",
  "hashtag.unfeature": "Ekki birta á notandasniði",
  "hashtag.unfollow": "Hætta að fylgjast með myllumerki",
  "hashtags.and_other": "…og {count, plural, other {# til viðbótar}}",
  "hints.profiles.followers_may_be_missing": "Fylgjendur frá þessum notanda gæti vantað.",
  "hints.profiles.follows_may_be_missing": "Aðila sem þessi notandi fylgist með gæti vantað.",
  "hints.profiles.posts_may_be_missing": "Sumar færslur frá þessum notanda gæti vantað.",
  "hints.profiles.see_more_followers": "Sjá fleiri fylgjendur á {domain}",
  "hints.profiles.see_more_follows": "Sjá fleiri sem þú fylgist með á {domain}",
  "hints.profiles.see_more_posts": "Sjá fleiri færslur á {domain}",
  "home.column_settings.show_quotes": "Birta tilvitnanir",
  "home.column_settings.show_reblogs": "Sýna endurbirtingar",
  "home.column_settings.show_replies": "Birta svör",
  "home.hide_announcements": "Fela auglýsingar",
  "home.pending_critical_update.body": "Uppfærðu Mastodon-þjóninn þinn eins fljótt og mögulegt er!",
  "home.pending_critical_update.link": "Skoða uppfærslur",
  "home.pending_critical_update.title": "Áríðandi öryggisuppfærsla er tiltæk!",
  "home.show_announcements": "Birta auglýsingar",
  "ignore_notifications_modal.disclaimer": "Mastodon getur ekki upplýst notendur um að þú hunsir tilkynningar frá þeim. Hunsun tilkynninga kemur ekki í veg fyrir að sjálf skilaboðin verði send.",
  "ignore_notifications_modal.filter_instead": "Sía frekar",
  "ignore_notifications_modal.filter_to_act_users": "Þú munt áfram geta samþykkt, hafnað eða kært notendur",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Síun hjálpar við að komast hjá mögulegum ruglingi",
  "ignore_notifications_modal.filter_to_review_separately": "Þú getur skoðað síaðar tilkynningar sérstaklega",
  "ignore_notifications_modal.ignore": "Hunsa tilkynningar",
  "ignore_notifications_modal.limited_accounts_title": "Hunsa tilkynningar frá aðgöngum sem umsjón er höfð með?",
  "ignore_notifications_modal.new_accounts_title": "Hunsa tilkynningar frá nýjum aðgöngum?",
  "ignore_notifications_modal.not_followers_title": "Hunsa tilkynningar frá fólki sem fylgist ekki með þér?",
  "ignore_notifications_modal.not_following_title": "Hunsa tilkynningar frá fólki sem þú fylgist ekki með?",
  "ignore_notifications_modal.private_mentions_title": "Hunsa tilkynningar frá óumbeðnum tilvísunum í einkaspjalli?",
  "info_button.label": "Hjálp",
  "info_button.what_is_alt_text": "<h1>Hvað er alt-texti?</h1> <p>Hjálpartexti eða ALT-myndatexti inniheldur lýsingu á myndefni fyrir fólk með ýmsar gerðir sjónskerðingar, fyrir tengingar með litla bandbreidd, eða til að gefa nánara samhengi fyrir myndefni.</p><p>Þú getur með þessu bætt almennt aðgengi og aukið skilning á efni sem þú birtir með því að skrifa skýran, skorinortan og hlutlægan alt-texta til vara.</p><ul><li>Lýstu mikilvægum atriðum</li>\\n<li>Hafðu yfirlit með þeim texta sem sést í myndum</li><li>Notaðu eðlilega setningaskipan</li><li>Forðastu óþarfar upplýsingar</li><li>Leggðu áherslu á aðalatriði í flóknu myndefni (eins og línuritum eða landakortum)</li></ul>",
  "interaction_modal.action": "Til að eiga við færsluna frá {name} þarftu að skrá þig inn á reikning þinn á þeim Mastodon-þjóni sem þú notar.",
  "interaction_modal.action_follow": "Til að fylgjast með {name}, þá þarftu að skrá þig inn á þann Mastodon-netþjón sem þú notar.",
  "interaction_modal.go": "Áfram",
  "interaction_modal.no_account_yet": "Ertu ekki ennþá með aðgang?",
  "interaction_modal.on_another_server": "Á öðrum netþjóni",
  "interaction_modal.on_this_server": "Á þessum netþjóni",
  "interaction_modal.title": "Skráðu inn til að halda áfram",
  "interaction_modal.username_prompt": "Til dæmis {example}",
  "intervals.full.days": "{number, plural, one {# dagur} other {# dagar}}",
  "intervals.full.hours": "{number, plural, one {# klukkustund} other {# klukkustundir}}",
  "intervals.full.minutes": "{number, plural, one {# mínúta} other {# mínútur}}",
  "keyboard_shortcuts.back": "Fara til baka",
  "keyboard_shortcuts.blocked": "Opna lista yfir útilokaða notendur",
  "keyboard_shortcuts.boost": "Endurbirta færslu",
  "keyboard_shortcuts.column": "Setja virkni í dálk",
  "keyboard_shortcuts.compose": "Setja virkni á textainnsetningarreit",
  "keyboard_shortcuts.description": "Lýsing",
  "keyboard_shortcuts.direct": "Opna dálk með einkaspjalli",
  "keyboard_shortcuts.down": "Fara neðar í listanum",
  "keyboard_shortcuts.enter": "Opna færslu",
  "keyboard_shortcuts.explore": "Opna tímalínu yfir vinsælt",
  "keyboard_shortcuts.favourite": "Eftirlætisfærsla",
  "keyboard_shortcuts.favourites": "Opna eftirlætislista",
  "keyboard_shortcuts.federated": "Opna sameiginlega tímalínu",
  "keyboard_shortcuts.heading": "Flýtileiðir á lyklaborði",
  "keyboard_shortcuts.home": "Opna heimatímalínu",
  "keyboard_shortcuts.hotkey": "Flýtilykill",
  "keyboard_shortcuts.legend": "Birta þessa skýringu",
  "keyboard_shortcuts.load_more": "Gera \"Hlaða inn meiru\"-hnappinn virkan",
  "keyboard_shortcuts.local": "Opna staðværa tímalínu",
  "keyboard_shortcuts.mention": "Minnast á höfund",
  "keyboard_shortcuts.muted": "Opna lista yfir þaggaða notendur",
  "keyboard_shortcuts.my_profile": "Opna notandasniðið þitt",
  "keyboard_shortcuts.notifications": "Opna tilkynningadálk",
  "keyboard_shortcuts.open_media": "Opna margmiðlunargögn",
  "keyboard_shortcuts.pinned": "Opna lista yfir festar færslur",
  "keyboard_shortcuts.profile": "Opna notandasnið höfundar",
  "keyboard_shortcuts.quote": "Vitna í færslu",
  "keyboard_shortcuts.reply": "Svara færslu",
  "keyboard_shortcuts.requests": "Opna lista yfir fylgjendabeiðnir",
  "keyboard_shortcuts.search": "Setja virkni í leitarreit",
  "keyboard_shortcuts.spoilers": "Birta/fela reit með aðvörun vegna efnis",
  "keyboard_shortcuts.start": "Opna \"komast í gang\" dálk",
  "keyboard_shortcuts.toggle_hidden": "Birta/fela texta á bak við aðvörun vegna efnis",
  "keyboard_shortcuts.toggle_sensitivity": "Birta/fela myndir",
  "keyboard_shortcuts.toot": "Byrja nýja færslu",
  "keyboard_shortcuts.top": "Færa efst á listann",
  "keyboard_shortcuts.translate": "að þýða færslu",
  "keyboard_shortcuts.unfocus": "Taka virkni úr textainnsetningarreit eða leit",
  "keyboard_shortcuts.up": "Fara ofar í listanum",
  "learn_more_link.got_it": "Náði því",
  "learn_more_link.learn_more": "Kanna nánar",
  "lightbox.close": "Loka",
  "lightbox.next": "Næsta",
  "lightbox.previous": "Fyrra",
  "lightbox.zoom_in": "Renna að raunstærð",
  "lightbox.zoom_out": "Renna að svo passi",
  "limited_account_hint.action": "Birta notandasniðið samt",
  "limited_account_hint.title": "Þetta notandasnið hefur verið falið af umsjónarmönnum {domain}.",
  "link_preview.author": "Frá {name}",
  "link_preview.more_from_author": "Meira frá {name}",
  "link_preview.shares": "{count, plural, one {{counter} færsla} other {{counter} færslur}}",
  "lists.add_member": "Bæta við",
  "lists.add_to_list": "Bæta á lista",
  "lists.add_to_lists": "Bæta {name} á lista",
  "lists.create": "Búa til",
  "lists.create_a_list_to_organize": "Búðu til nýjan lista til að skipuleggja heimastreymið þitt",
  "lists.create_list": "Búa til lista",
  "lists.delete": "Eyða lista",
  "lists.done": "Lokið",
  "lists.edit": "Breyta lista",
  "lists.exclusive": "Fela meðlimi í heimastreyminu",
  "lists.exclusive_hint": "Ef einhver er á þessum lista, geturðu falið viðkomandi í heimastreyminu þínu til að komast hjá því að sjá færslurnar þeirra í tvígang.",
  "lists.find_users_to_add": "Finndu notendur til að bæta við",
  "lists.list_members_count": "{count, plural, one {# meðlimur} other {# meðlimir}}",
  "lists.list_name": "Heiti lista",
  "lists.new_list_name": "Heiti á nýjum lista",
  "lists.no_lists_yet": "Ennþá engir listar.",
  "lists.no_members_yet": "Ennþá engir meðlimir.",
  "lists.no_results_found": "Engar niðurstöður fundust.",
  "lists.remove_member": "Fjarlægja",
  "lists.replies_policy.followed": "Allra notenda sem fylgst er með",
  "lists.replies_policy.list": "Meðlima listans",
  "lists.replies_policy.none": "Engra",
  "lists.save": "Vista",
  "lists.search": "Leita",
  "lists.show_replies_to": "Hafa með svör frá meðlimum lista til",
  "load_pending": "{count, plural, one {# nýtt atriði} other {# ný atriði}}",
  "loading_indicator.label": "Hleð inn…",
  "media_gallery.hide": "Fela",
  "moved_to_account_banner.text": "Aðgangurinn þinn {disabledAccount} er óvirkur í augnablikinu vegna þess að þú fluttir þig yfir á {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Fela úr tilkynningum",
  "mute_modal.hide_options": "Fela valkosti",
  "mute_modal.indefinite": "Þar til ég hætti að þagga niður í viðkomandi",
  "mute_modal.show_options": "Birta valkosti",
  "mute_modal.they_can_mention_and_follow": "Viðkomandi geta minnst á þig og fylgst með þér, en þú munt ekki sjá þá.",
  "mute_modal.they_wont_know": "Viðkomandi aðilar munu ekki vita að þaggað hefur verið niður í þeim.",
  "mute_modal.title": "Þagga niður í notanda?",
  "mute_modal.you_wont_see_mentions": "Þú munt ekki sjá færslur sem minnast á viðkomandi aðila.",
  "mute_modal.you_wont_see_posts": "Viðkomandi geta áfram séð færslurnar þínar en þú munt ekki sjá færslurnar þeirra.",
  "navigation_bar.about": "Um hugbúnaðinn",
  "navigation_bar.account_settings": "Lykilorð og öryggi",
  "navigation_bar.administration": "Stjórnun",
  "navigation_bar.advanced_interface": "Opna í ítarlegu vefviðmóti",
  "navigation_bar.automated_deletion": "Sjálfvirk eyðing færslna",
  "navigation_bar.blocks": "Útilokaðir notendur",
  "navigation_bar.bookmarks": "Bókamerki",
  "navigation_bar.collections": "Söfn",
  "navigation_bar.direct": "Einkaspjall",
  "navigation_bar.domain_blocks": "Útilokuð lén",
  "navigation_bar.favourites": "Eftirlæti",
  "navigation_bar.filters": "Þögguð orð",
  "navigation_bar.follow_requests": "Beiðnir um að fylgjast með",
  "navigation_bar.followed_tags": "Vöktuð myllumerki",
  "navigation_bar.follows_and_followers": "Fylgist með og fylgjendur",
  "navigation_bar.import_export": "Inn- og útflutningur",
  "navigation_bar.lists": "Listar",
  "navigation_bar.live_feed_local": "Bein streymi (á netþjóni)",
  "navigation_bar.live_feed_public": "Bein streymi (opinber)",
  "navigation_bar.logout": "Útskráning",
  "navigation_bar.moderation": "Umsjón",
  "navigation_bar.more": "Meira",
  "navigation_bar.mutes": "Þaggaðir notendur",
  "navigation_bar.opened_in_classic_interface": "Færslur, notendaaðgangar og aðrar sérhæfðar síður eru sjálfgefið opnaðar í klassíska vefviðmótinu.",
  "navigation_bar.preferences": "Kjörstillingar",
  "navigation_bar.privacy_and_reach": "Gagnaleynd og útbreiðsla",
  "navigation_bar.search": "Leita",
  "navigation_bar.search_trends": "Leita / Vinsælt",
  "navigation_panel.collapse_followed_tags": "Fella saman valmynd myllumerkja sem fylgst er með",
  "navigation_panel.collapse_lists": "Fella saman valmyndalista",
  "navigation_panel.expand_followed_tags": "Fletta út valmynd myllumerkja sem fylgst er með",
  "navigation_panel.expand_lists": "Fletta út valmyndalista",
  "not_signed_in_indicator.not_signed_in": "Þú þarft að skrá þig inn til að nota þetta tilfang.",
  "notification.added_to_collection": "{name} bætti þér í safn",
  "notification.admin.report": "{name} kærði {target}",
  "notification.admin.report_account": "{name} kærði {count, plural, one {eina færslu} other {# færslur}} frá {target} fyrir {category}",
  "notification.admin.report_account_other": "{name} kærði {count, plural, one {eina færslu} other {# færslur}} frá {target}",
  "notification.admin.report_statuses": "{name} kærði {target} fyrir {category}",
  "notification.admin.report_statuses_other": "{name} kærði {target}",
  "notification.admin.sign_up": "{name} skráði sig",
  "notification.admin.sign_up.name_and_others": "{name} og {count, plural, one {# í viðbót hefur} other {# í viðbót hafa}} skráð sig",
  "notification.annual_report.message": "Ársuppgjörið {year} bíður á #Wrapstodon! Afhjúpaðu hvað bar hæst á árinu og minnistæðustu augnablikin á Mastodon!",
  "notification.annual_report.view": "Skoða ársuppgjör á #Wrapstodon",
  "notification.collection_update": "{name} breytti safni sem þú ert í",
  "notification.favourite": "{name} setti færsluna þína í eftirlæti",
  "notification.favourite.name_and_others_with_link": "{name} og <a>{count, plural, one {# í viðbót hefur} other {# í viðbót hafa}}</a> sett færsluna þína í eftirlæti",
  "notification.favourite_pm": "{name} setti í eftirlæti færslu í einkaspjalli þar sem þú minntist á viðkomandi",
  "notification.favourite_pm.name_and_others_with_link": "{name} og <a>{count, plural, one {# í viðbót} other {# í viðbót}}</a> settu í eftirlæti færslu í einkaspjalli þar sem þú minntist á viðkomandi",
  "notification.follow": "{name} fylgist með þér",
  "notification.follow.name_and_others": "{name} og <a>{count, plural, one {# í viðbót fylgdist} other {# í viðbót fylgdust}}</a> með þér",
  "notification.follow_request": "{name} hefur beðið um að fylgjast með þér",
  "notification.follow_request.name_and_others": "{name} og {count, plural, one {# í viðbót hefur} other {# í viðbót hafa}} beðið um að fylgjast með þér",
  "notification.label.mention": "Minnst á",
  "notification.label.private_mention": "Einkaspjall",
  "notification.label.private_reply": "Einkasvar",
  "notification.label.quote": "{name} vitnaði í færsluna þína",
  "notification.label.reply": "Svara",
  "notification.mention": "Minnst á",
  "notification.mentioned_you": "{name} minntist á þig",
  "notification.moderation-warning.learn_more": "Kanna nánar",
  "notification.moderation_warning": "Þú hefur fengið aðvörun frá umsjónarmanni",
  "notification.moderation_warning.action_delete_statuses": "Sumar færslurnar þínar hafa verið fjarlægðar.",
  "notification.moderation_warning.action_disable": "Aðgangurinn þinn hefur verið gerður óvirkur.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Sumar færslurnar þínar hafa verið merktar sem viðkvæmt efni.",
  "notification.moderation_warning.action_none": "Aðgangurinn þinn hefur fengið aðvörun frá umsjónarmanni.",
  "notification.moderation_warning.action_sensitive": "Færslur þínar á verða héðan í frá merktar sem viðkvæmar.",
  "notification.moderation_warning.action_silence": "Notandaaðgangurinn þinn hefur verið takmarkaður.",
  "notification.moderation_warning.action_suspend": "Notandaaðgangurinn þinn hefur verið settur í frysti.",
  "notification.own_poll": "Könnuninni þinni er lokið",
  "notification.poll": "Könnun sem þú greiddir atkvæði í er lokið",
  "notification.quoted_update": "{name} breytti færslu sem þú hefur vitnað í",
  "notification.reblog": "{name} endurbirti færsluna þína",
  "notification.reblog.name_and_others_with_link": "{name} og <a>{count, plural, one {# í viðbót hefur} other {# í viðbót hafa}}</a> endurbirt færsluna þína",
  "notification.relationships_severance_event": "Missti tengingar við {name}",
  "notification.relationships_severance_event.account_suspension": "Stjórnandi á {from} hefur fryst {target}, sem þýðir að þú færð ekki lengur skilaboð frá viðkomandi né átt í samskiptum við viðkomandi.",
  "notification.relationships_severance_event.domain_block": "Stjórnandi á {from} hefur lokað á {target} og þar með {followersCount} fylgjendur þína auk {followingCount, plural, one {# aðgangs} other {# aðganga}} sem þú fylgist með.",
  "notification.relationships_severance_event.learn_more": "Kanna nánar",
  "notification.relationships_severance_event.user_domain_block": "Þú hefur lokað á {target} og þar með fjarlægt {followersCount} fylgjendur þína auk {followingCount, plural, one {# aðgangs} other {# aðganga}} sem þú fylgist með.",
  "notification.status": "{name} sendi inn rétt í þessu",
  "notification.update": "{name} breytti færslu",
  "notification_requests.accept": "Samþykkja",
  "notification_requests.accept_multiple": "{count, plural, one {Samþykkja # beiðni…} other {Samþykkja # beiðnir…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Samþykkja beiðni} other {Samþykkja beiðnir}}",
  "notification_requests.confirm_accept_multiple.message": "Þú ert að fara að samþykkja {count, plural, one {eina beiðni um tilkynningar} other {# beiðnir um tilkynningar}}. Ertu viss um að þú viljir halda áfram?",
  "notification_requests.confirm_accept_multiple.title": "Samþykkja beiðnir um tilkynningar?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Hafna beiðni} other {Hafna beiðnum}}",
  "notification_requests.confirm_dismiss_multiple.message": "Þú ert að fara að hunsa {count, plural, one {eina beiðni um tilkynningar} other {# beiðnir um tilkynningar}}. Þú munt ekki eiga auðvelt með að skoða {count, plural, one {hana} other {þær}} aftur síðar. Ertu viss um að þú viljir halda áfram?",
  "notification_requests.confirm_dismiss_multiple.title": "Hunsa beiðnir um tilkynningar?",
  "notification_requests.dismiss": "Hafna",
  "notification_requests.dismiss_multiple": "{count, plural, one {Hafna # beiðni…} other {Hafna # beiðnum…}}",
  "notification_requests.edit_selection": "Breyta",
  "notification_requests.exit_selection": "Lokið",
  "notification_requests.explainer_for_limited_account": "Tilkynningar frá þessum notanda hafa verið síaðar þar sem aðgangur hans hefur verið takmarkaður af umsjónarmanni.",
  "notification_requests.explainer_for_limited_remote_account": "Tilkynningar frá þessum notanda hafa verið síaðar þar sem aðgangurinn eða netþjónn hans hefur verið takmarkaður af umsjónarmanni.",
  "notification_requests.maximize": "Hámarka",
  "notification_requests.minimize_banner": "Minnka borða með síuðum tilkynningum",
  "notification_requests.notifications_from": "Tilkynningar frá {name}",
  "notification_requests.title": "Síaðar tilkynningar",
  "notification_requests.view": "Skoða tilkynningar",
  "notifications.clear": "Hreinsa tilkynningar",
  "notifications.clear_confirmation": "Ertu viss um að þú viljir endanlega eyða öllum tilkynningunum þínum?",
  "notifications.clear_title": "Hreinsa tilkynningar?",
  "notifications.column_settings.admin.report": "Nýjar kærur:",
  "notifications.column_settings.admin.sign_up": "Nýjar skráningar:",
  "notifications.column_settings.alert": "Tilkynningar á skjáborði",
  "notifications.column_settings.favourite": "Eftirlæti:",
  "notifications.column_settings.filter_bar.advanced": "Birta alla flokka",
  "notifications.column_settings.filter_bar.category": "Skyndisíustika",
  "notifications.column_settings.follow": "Nýir fylgjendur:",
  "notifications.column_settings.follow_request": "Nýjar beiðnir um að fylgjast með:",
  "notifications.column_settings.group": "Hópur",
  "notifications.column_settings.mention": "Tilvísanir:",
  "notifications.column_settings.poll": "Niðurstöður könnunar:",
  "notifications.column_settings.push": "Ýti-tilkynningar",
  "notifications.column_settings.quote": "Tilvitnanir:",
  "notifications.column_settings.reblog": "Endurbirtingar:",
  "notifications.column_settings.show": "Sýna í dálki",
  "notifications.column_settings.sound": "Spila hljóð",
  "notifications.column_settings.status": "Nýjar færslur:",
  "notifications.column_settings.unread_notifications.category": "Ólesnar tilkynningar",
  "notifications.column_settings.unread_notifications.highlight": "Áherslulita ólesnar tilkynningar",
  "notifications.column_settings.update": "Breytingar:",
  "notifications.filter.all": "Allt",
  "notifications.filter.boosts": "Endurbirtingar",
  "notifications.filter.favourites": "Eftirlæti",
  "notifications.filter.follows": "Fylgist með",
  "notifications.filter.mentions": "Tilvísanir",
  "notifications.filter.polls": "Niðurstöður könnunar",
  "notifications.filter.statuses": "Uppfærslur frá fólki sem þú fylgist með",
  "notifications.grant_permission": "Veita heimild.",
  "notifications.group": "{count} tilkynningar",
  "notifications.mark_as_read": "Merkja allar tilkynningar sem lesnar",
  "notifications.permission_denied": "Tilkynningar á skjáborði eru ekki aðgengilegar megna áður hafnaðra beiðna fyrir vafra",
  "notifications.permission_denied_alert": "Ekki var hægt að virkja tilkynningar á skjáborði, þar sem heimildum fyrir vafra var áður hafnað",
  "notifications.permission_required": "Tilkynningar á skjáborði eru ekki aðgengilegar þar sem nauðsynlegar heimildir hafa ekki verið veittar.",
  "notifications.policy.accept": "Samþykkja",
  "notifications.policy.accept_hint": "Birta í tilkynningum",
  "notifications.policy.drop": "Hunsa",
  "notifications.policy.drop_hint": "Senda út í tómið, svo það sjáist aldrei framar",
  "notifications.policy.filter": "Sía",
  "notifications.policy.filter_hint": "Senda í pósthólf fyrir síaðar tilkynningar",
  "notifications.policy.filter_limited_accounts_hint": "Takmarkað af umsjónarmönnum netþjóns",
  "notifications.policy.filter_limited_accounts_title": "Aðgangar í umsjón",
  "notifications.policy.filter_new_accounts.hint": "Útbúið {days, plural, one {síðasta daginn} other {síðustu # daga}}",
  "notifications.policy.filter_new_accounts_title": "Nýir notendur",
  "notifications.policy.filter_not_followers_hint": "Þar með talið fólk sem hefur fylgst með þér í minna en {days, plural, one {einn dag} other {# daga}}",
  "notifications.policy.filter_not_followers_title": "Fólk sem fylgist ekki með þér",
  "notifications.policy.filter_not_following_hint": "Þar til þú samþykkir viðkomandi handvirkt",
  "notifications.policy.filter_not_following_title": "Fólk sem þú fylgist ekki með",
  "notifications.policy.filter_private_mentions_hint": "Síað nema það sé í svari við einhverju þar sem þú minntist á viðkomandi eða ef þú fylgist með sendandanum",
  "notifications.policy.filter_private_mentions_title": "Óumbeðið einkaspjall",
  "notifications.policy.title": "Sýsla með tilkynningar frá…",
  "notifications_permission_banner.enable": "Virkja tilkynningar á skjáborði",
  "notifications_permission_banner.how_to_control": "Til að taka á móti tilkynningum þegar Mastodon er ekki opið, skaltu virkja tilkynningar á skjáborði. Þegar þær eru orðnar virkar geturðu stýrt nákvæmlega hverskonar atvik framleiða tilkynningar með því að nota {icon}-hnappinn hér fyrir ofan.",
  "notifications_permission_banner.title": "Aldrei missa af neinu",
  "onboarding.follows.back": "Til baka",
  "onboarding.follows.empty": "Því miður er ekki hægt að birta neinar niðurstöður í augnablikinu. Þú getur reynt að nota leitina eða skoðað könnunarsíðuna til að finna fólk til að fylgjast með, nú eða prófað aftur síðar.",
  "onboarding.follows.next": "Næsta: Settu upp notandasniðið þitt",
  "onboarding.follows.search": "Leita",
  "onboarding.follows.title": "Þú ættir að fylgjast með fólki til að komast í gang",
  "onboarding.profile.discoverable": "Gera notandasniðið mitt uppgötvanlegt",
  "onboarding.profile.discoverable_hint": "Þegar þú velur að hægt sé að uppgötva þig á Mastodon, munu færslurnar þínar birtast í leitarniðurstöðum og vinsældalistum, auk þess sem stungið verður upp á notandasniðinu þínu við fólk sem er með svipuð áhugamál og þú.",
  "onboarding.profile.display_name": "Birtingarnafn",
  "onboarding.profile.display_name_hint": "Fullt nafn þitt eða eitthvað til gamans…",
  "onboarding.profile.finish": "Ljúka",
  "onboarding.profile.note": "Æviágrip",
  "onboarding.profile.note_hint": "Þú getur @minnst á annað fólk eða #myllumerki…",
  "onboarding.profile.title": "Uppsetning notandasniðs",
  "onboarding.profile.upload_avatar": "Sendu inn auðkennismynd",
  "onboarding.profile.upload_header": "Sendu inn bakgrunnsmynd í haus notandasniðs",
  "password_confirmation.exceeds_maxlength": "Staðfesting lykilorðs; fer fram úr hámarkslengd",
  "password_confirmation.mismatching": "Staðfesting lykilorðs; samsvara ekki",
  "picture_in_picture.restore": "Setja til baka",
  "poll.closed": "Lokuð",
  "poll.refresh": "Endurlesa",
  "poll.reveal": "Skoða niðurstöður",
  "poll.total_people": "{count, plural, one {# aðili} other {# aðilar}}",
  "poll.total_votes": "{count, plural, one {# atkvæði} other {# atkvæði}}",
  "poll.vote": "Greiða atkvæði",
  "poll.voted": "Þú kaust þetta svar",
  "poll.votes": "{votes, plural, one {# atkvæði} other {# atkvæði}}",
  "poll_button.add_poll": "Bæta við könnun",
  "poll_button.remove_poll": "Fjarlægja könnun",
  "privacy.change": "Aðlaga gagnaleynd færslu",
  "privacy.direct.long": "Allir sem minnst er á í færslunni",
  "privacy.direct.short": "Einkaspjall",
  "privacy.private.long": "Einungis þeir sem fylgjast með þér",
  "privacy.private.short": "Fylgjendur",
  "privacy.public.long": "Hver sem er, á og utan Mastodon",
  "privacy.public.short": "Opinbert",
  "privacy.quote.anyone": "{visibility}, tilvitnanir leyfðar",
  "privacy.quote.disabled": "{visibility}, tilvitnanir eru óvirkar",
  "privacy.quote.limited": "{visibility}, tilvitnanir eru takmarkaðar",
  "privacy.unlisted.additional": "Þetta hegðar sér eins og opinber færsla, fyrir utan að færslan birtist ekki í beinum streymum eða myllumerkjum, né heldur í Mastodon-leitum jafnvel þótt þú hafir valið að falla undir slíkt í notandasniðinu þínu.",
  "privacy.unlisted.long": "Falið frá leitarniðurstöðum Mastodon, vinsældalistum og opinberum tímalínum",
  "privacy.unlisted.short": "Hljóðlátt opinbert",
  "privacy_policy.last_updated": "Síðast uppfært {date}",
  "privacy_policy.title": "Persónuverndarstefna",
  "quote_error.edit": "Ekki er hægt að bæta við tilvitnunum þegar færslum er breytt.",
  "quote_error.poll": "Ekki er leyft að vitna í kannanir.",
  "quote_error.private_mentions": "Tilvitnanir eru ekki leyfðar í beinu einkaspjalli.",
  "quote_error.quote": "Einungis ein tilvitnun er leyfð í einu.",
  "quote_error.unauthorized": "Þú hefur ekki heimild til að vitna í þessa færslu.",
  "quote_error.upload": "Ekki er leyft að vitna í myndviðhengi.",
  "recommended": "Mælt með",
  "refresh": "Endurlesa",
  "regeneration_indicator.please_stand_by": "Hinkraðu við.",
  "regeneration_indicator.preparing_your_home_feed": "Undirbý heimastreymið þitt…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "Fyrir {number, plural, one {# degi} other {# dögum}} síðan",
  "relative_time.full.hours": "Fyrir {number, plural, one {# klukkustund} other {# klukkustundum}} síðan",
  "relative_time.full.just_now": "í þessu",
  "relative_time.full.minutes": "Fyrir {number, plural, one {# mínútu} other {# mínútum}} síðan",
  "relative_time.full.seconds": "Fyrir {number, plural, one {# sekúndu} other {# sekúndum}} síðan",
  "relative_time.hours": "{number}kl.",
  "relative_time.just_now": "núna",
  "relative_time.minutes": "{number}mín",
  "relative_time.seconds": "{number}sek",
  "relative_time.today": "í dag",
  "remove_quote_hint.button_label": "Náði því",
  "remove_quote_hint.message": "Þú getur gert það úr {icon} valmyndinni.",
  "remove_quote_hint.title": "Viltu fjarlægja tilvitnuðu færsluna þína?",
  "reply_indicator.attachments": "{count, plural, one {# viðhengi} other {# viðhengi}}",
  "reply_indicator.cancel": "Hætta við",
  "reply_indicator.poll": "Könnun",
  "report.block": "Útiloka",
  "report.block_explanation": "Þú munt ekki sjá færslurnar þeirra. Þeir munu ekki geta séð færslurnar þínar eða fylgst með þér. Þeir munu ekki geta séð að lokað sé á þá.",
  "report.categories.legal": "Lagalegt",
  "report.categories.other": "Annað",
  "report.categories.spam": "Ruslpóstur",
  "report.categories.violation": "Efnið brýtur gegn einni eða fleiri reglum netþjónsins",
  "report.category.subtitle": "Veldu hvað samsvarar best",
  "report.category.title": "Segðu okkur hvað er í gangi með þetta {type}-atriði",
  "report.category.title_account": "notandasnið",
  "report.category.title_status": "færsla",
  "report.close": "Lokið",
  "report.collection_comment": "Afhverju viltu tilkynna þetta safn?",
  "report.comment.title": "Er eitthvað annað sem þú heldur að við ættum að vita?",
  "report.forward": "Áframsenda til {target}",
  "report.forward_hint": "Notandaaðgangurinn er af öðrum vefþjóni. Á einnig að senda nafnlaust afrit af kærunni þangað?",
  "report.mute": "Þagga niður",
  "report.mute_explanation": "Þú munt ekki sjá færslurnar þeirra. Þeir munu samt geta séð færslurnar þínar eða fylgst með þér, en munu ekki geta séð að þaggað sé niður í þeim.",
  "report.next": "Næsta",
  "report.placeholder": "Viðbótarathugasemdir",
  "report.reasons.dislike": "Mér líkar það ekki",
  "report.reasons.dislike_description": "Þetta er ekki eitthvað sem þið viljið sjá",
  "report.reasons.legal": "Það er ólöglegt",
  "report.reasons.legal_description": "Þú hefur trú um að það brjóti í bága við landslög þar sem vefþjónnin er hýstur",
  "report.reasons.other": "Það er eitthvað annað",
  "report.reasons.other_description": "Vandamálið fellur ekki í aðra flokka",
  "report.reasons.spam": "Þetta er ruslpóstur",
  "report.reasons.spam_description": "Slæmir tenglar, fölsk samskipti eða endurtekin svör",
  "report.reasons.violation": "Það gengur þvert á reglur fyrir netþjóninn",
  "report.reasons.violation_description": "Þið eruð meðvituð um að þetta brýtur sértækar reglur",
  "report.rules.subtitle": "Veldu allt sem á við",
  "report.rules.title": "Hvaða reglur eru brotnar?",
  "report.statuses.subtitle": "Veldu allt sem á við",
  "report.statuses.title": "Eru einhverjar færslur sem styðja þessa kæru?",
  "report.submission_error": "Ekki var hægt að senda inn kæruna",
  "report.submission_error_details": "Athugaðu nettenginguna þína og prófaðu aftur síðar.",
  "report.submit": "Senda inn",
  "report.target": "Kæri {target}",
  "report.thanks.take_action": "Hér eru nokkrir valkostir til að stýra hvað þú sérð á Mastodon:",
  "report.thanks.take_action_actionable": "Á meðan við yfirförum þetta, geturðu tekið til aðgerða gegn @{name}:",
  "report.thanks.title": "Viltu ekki sjá þetta?",
  "report.thanks.title_actionable": "Takk fyrir tilkynninguna, við munum skoða málið.",
  "report.unfollow": "Hætta að fylgjast með @{name}",
  "report.unfollow_explanation": "Þú ert að fylgjast með þessum aðgangi. Til að hætta að sjá viðkomandi færslur á streyminu þínu, skaltu hætta að fylgjast með viðkomandi.",
  "report_notification.attached_statuses": "{count, plural, one {{count} færsla} other {{count} færslur}} viðhengdar",
  "report_notification.categories.legal": "Löglegt",
  "report_notification.categories.legal_sentence": "ólöglegt efni",
  "report_notification.categories.other": "Annað",
  "report_notification.categories.other_sentence": "annað",
  "report_notification.categories.spam": "Ruslpóstur",
  "report_notification.categories.spam_sentence": "ruslpóstur",
  "report_notification.categories.violation": "Brot á reglum",
  "report_notification.categories.violation_sentence": "brot á reglum",
  "report_notification.open": "Opin kæra",
  "search.clear": "Hreinsa leit",
  "search.no_recent_searches": "Engar nýlegar leitir",
  "search.placeholder": "Leita",
  "search.quick_action.account_search": "Notandasnið sem samsvara {x}",
  "search.quick_action.go_to_account": "Fara á notandasnið {x}",
  "search.quick_action.go_to_hashtag": "Fara á myllumerkið {x}",
  "search.quick_action.open_url": "Opna slóð í Mastodon",
  "search.quick_action.status_search": "Færslur sem samsvara {x}",
  "search.search_or_paste": "Leita eða líma slóð",
  "search_popout.full_text_search_disabled_message": "Ekki tiltækt á {domain}.",
  "search_popout.full_text_search_logged_out_message": "Aðeins tiltækt eftir innskráningu.",
  "search_popout.language_code": "ISO-kóði tungumáls",
  "search_popout.options": "Leitarvalkostir",
  "search_popout.quick_actions": "Flýtiaðgerðir",
  "search_popout.recent": "Nýlegar leitir",
  "search_popout.specific_date": "tiltekin dagsetning",
  "search_popout.user": "notandi",
  "search_results.accounts": "Notendasnið",
  "search_results.all": "Allt",
  "search_results.hashtags": "Myllumerki",
  "search_results.no_results": "Engar niðurstöður.",
  "search_results.no_search_yet": "Prófaðu að leita að færslum, notendum eða myllumerkjum.",
  "search_results.see_all": "Sjá allt",
  "search_results.statuses": "Færslur",
  "search_results.title": "Leita að {q}\"",
  "server_banner.about_active_users": "Folk sem hefur notað þennan netþjón síðustu 30 daga (virkir notendur í mánuðinum)",
  "server_banner.active_users": "virkir notendur",
  "server_banner.administered_by": "Stýrt af:",
  "server_banner.is_one_of_many": "{domain} er einn af fjölmörgum óháðum Mastodon-þjónum sem þú getur notað til að taka þátt í fediverse-samfélaginu.",
  "server_banner.more_about_this_server": "Nánar um þennan netþjón",
  "server_banner.server_stats": "Tölfræði þjóns:",
  "sign_in_banner.create_account": "Búa til notandaaðgang",
  "sign_in_banner.follow_anyone": "Fylgstu með hverjum sem er í þessum samtvinnaða heimi og skoðaðu allt í tímaröð. Engin reiknirit, auglýsingar eða smellbeitur.",
  "sign_in_banner.mastodon_is": "Mastodon er besta leiðin til að fylgjast með hvað sé í gangi.",
  "sign_in_banner.sign_in": "Skrá inn",
  "sign_in_banner.sso_redirect": "Skrá inn eða nýskrá",
  "skip_links.hotkey": "<span>Flýtilykill</span> {hotkey}",
  "skip_links.skip_to_content": "Fara í aðalefni",
  "skip_links.skip_to_navigation": "Fara í aðalflakk",
  "status.admin_account": "Opna umsjónarviðmót fyrir @{name}",
  "status.admin_domain": "Opna umsjónarviðmót fyrir @{domain}",
  "status.admin_status": "Opna þessa færslu í umsjónarviðmótinu",
  "status.all_disabled": "Endurbirtingar og tilvitnanir eru óvirkar",
  "status.block": "Útiloka @{name}",
  "status.bookmark": "Bókamerki",
  "status.cancel_reblog_private": "Taka úr endurbirtingu",
  "status.cannot_quote": "Þú hefur ekki heimild til að vitna í þessa færslu",
  "status.cannot_reblog": "Þessa færslu er ekki hægt að endurbirta",
  "status.contains_quote": "Inniheldur tilvitnun",
  "status.context.loading": "Hleð inn fleiri svörum",
  "status.context.loading_error": "Gat ekki hlaðið inn nýjum svörum",
  "status.context.loading_success": "Nýjum svörum hlaðið inn",
  "status.context.more_replies_found": "Fleiri svör fundust",
  "status.context.retry": "Reyna aftur",
  "status.context.show": "Sýna",
  "status.continued_thread": "Hélt samtali áfram",
  "status.copy": "Afrita tengil í færslu",
  "status.delete": "Eyða",
  "status.delete.success": "Færslu eytt",
  "status.detailed_status": "Nákvæm spjallþráðasýn",
  "status.direct": "Einkaspjall við @{name}",
  "status.direct_indicator": "Einkaspjall",
  "status.edit": "Breyta",
  "status.edited": "Síðast breytt {date}",
  "status.edited_x_times": "Breytt {count, plural, one {{count} sinni} other {{count} sinnum}}",
  "status.embed": "Ná í innfellanlegan kóða",
  "status.favourite": "Eftirlæti",
  "status.favourites_count": "{count, plural, one {{counter} eftirlæti} other {{counter} eftirlæti}}",
  "status.filter": "Sía þessa færslu",
  "status.history.created": "{name} útbjó {date}",
  "status.history.edited": "{name} breytti {date}",
  "status.load_more": "Hlaða inn meiru",
  "status.media.open": "Smelltu til að opna",
  "status.media.show": "Smelltu til að birta",
  "status.media_hidden": "Mynd er falin",
  "status.mention": "Minnast á @{name}",
  "status.more": "Meira",
  "status.mute": "Þagga niður í @{name}",
  "status.mute_conversation": "Þagga niður í samtali",
  "status.open": "Opna þessa færslu",
  "status.pin": "Festa á notandasnið",
  "status.quote": "Tilvitnun",
  "status.quote.cancel": "Hætta við tilvitnun",
  "status.quote_error.blocked_account_hint.title": "Þessi færsla er falin vegna þess að ú hefur lokað á @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Þessi færsla er falin vegna þess að ú hefur lokað á {domain}.",
  "status.quote_error.filtered": "Falið vegna einnar síu sem er virk",
  "status.quote_error.limited_account_hint.action": "Birta samt",
  "status.quote_error.limited_account_hint.title": "Þessi notandaaðgangur hefur verið falinn af stjórnendum á {domain}.",
  "status.quote_error.muted_account_hint.title": "Þessi færsla er falin vegna þess að ú hefur þaggað niður í @{name}.",
  "status.quote_error.not_available": "Færsla ekki tiltæk",
  "status.quote_error.pending_approval": "Færsla í bið",
  "status.quote_error.pending_approval_popout.body": "Á Mastodon geturðu stjórnað því hvort aðrir geti vitnað í þig. Þessi færsla bíður eftir samþykki upprunalegs höfundar.",
  "status.quote_error.revoked": "Færsla fjarlægð af höfundi",
  "status.quote_followers_only": "Einungis fylgjendur geta vitnað í þessa færslu",
  "status.quote_manual_review": "Höfundur mun yfirfara handvirkt",
  "status.quote_noun": "Tilvitnun",
  "status.quote_policy_change": "Breyttu því hver getur tilvitnað",
  "status.quote_post_author": "Vitnaði í færslu frá @{name}",
  "status.quote_private": "Ekki er hægt að vitna í einkafærslur",
  "status.quotes.empty": "Enginn hefur ennþá vitnað í þessa færslu. Þegar einhver gerir það, mun það birtast hér.",
  "status.quotes.local_other_disclaimer": "Tilvitnanir sem höfundur hafnar verða ekki birtar.",
  "status.quotes.remote_other_disclaimer": "Aðeins tilvitnanir frá {domain} munu birtast hér. Tilvitnanir sem höfundur hafnar verða ekki birtar.",
  "status.quotes_count": "{count, plural, one {{counter} tilvitnun} other {{counter} tilvitnanir}}",
  "status.read_more": "Lesa meira",
  "status.reblog": "Endurbirting",
  "status.reblog_or_quote": "Endurbirta eða vitna í færslu",
  "status.reblog_private": "Deildu aftur með þeim sem fylgjast með þér",
  "status.reblogged_by": "{name} endurbirti",
  "status.reblogs.empty": "Enginn hefur ennþá endurbirt þessa færslu. Þegar einhver gerir það, mun það birtast hér.",
  "status.reblogs_count": "{count, plural, one {{counter} endurbirting} other {{counter} endurbirtingar}}",
  "status.redraft": "Eyða og endurvinna drög",
  "status.remove_bookmark": "Fjarlægja bókamerki",
  "status.remove_favourite": "Fjarlægja úr eftirlætum",
  "status.remove_quote": "Fjarlægja",
  "status.replied_in_thread": "Svaraði í samtali",
  "status.replied_to": "Svaraði til {name}",
  "status.reply": "Svara",
  "status.replyAll": "Svara þræði",
  "status.report": "Kæra @{name}",
  "status.request_quote": "Beiðni um tilvitnun",
  "status.revoke_quote": "Fjarlægja færsluna mína úr færslu frá @{name}",
  "status.sensitive_warning": "Viðkvæmt efni",
  "status.share": "Deila",
  "status.show_less_all": "Sýna minna fyrir allt",
  "status.show_more_all": "Sýna meira fyrir allt",
  "status.show_original": "Sýna upprunalega",
  "status.title.with_attachments": "{user} birti {attachmentCount, plural, one {viðhengi} other {{attachmentCount} viðhengi}}",
  "status.translate": "Þýða",
  "status.translated_from_with": "Þýtt úr {lang} með {provider}",
  "status.uncached_media_warning": "Forskoðun ekki tiltæk",
  "status.unmute_conversation": "Hætta að þagga niður í samtali",
  "status.unpin": "Losa af notandasniði",
  "subscribed_languages.lead": "Einungis færslur á völdum tungumálum munu birtast á upphafssíðu og tímalínum þínum eftir þessa breytingu. Veldu ekkert til að sjá færslur á öllum tungumálum.",
  "subscribed_languages.save": "Vista breytingar",
  "subscribed_languages.target": "Breyta tungumálum í áskrift fyrir {target}",
  "tabs_bar.home": "Heim",
  "tabs_bar.menu": "Valmynd",
  "tabs_bar.notifications": "Tilkynningar",
  "tabs_bar.publish": "Ný færsla",
  "tabs_bar.search": "Leita",
  "tag.remove": "Fjarlægja",
  "terms_of_service.effective_as_of": "Gildir frá og með {date}",
  "terms_of_service.title": "Þjónustuskilmálar",
  "terms_of_service.upcoming_changes_on": "Væntanlegar breytingar þann {date}",
  "time_remaining.days": "{number, plural, one {# dagur} other {# dagar}} eftir",
  "time_remaining.hours": "{number, plural, one {# klukkustund} other {# klukkustundir}} eftir",
  "time_remaining.minutes": "{number, plural, one {# mínúta} other {# mínútur}} eftir",
  "time_remaining.moments": "Tími eftir",
  "time_remaining.seconds": "{number, plural, one {# sekúnda} other {# sekúndur}} eftir",
  "trends.counter_by_accounts": "{count, plural, one {{counter} aðili} other {{counter} manns}} {days, plural, one {síðasta sólarhringinn} other {síðustu {days} daga}}",
  "trends.trending_now": "Vinsælt núna",
  "ui.beforeunload": "Drögin tapast ef þú ferð út úr Mastodon.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Dragðu-og-slepptu hér til að senda inn",
  "upload_button.label": "Bæta við myndum, myndskeiði eða hljóðskrá",
  "upload_error.limit": "Fór yfir takmörk á innsendingum skráa.",
  "upload_error.poll": "Innsending skráa er ekki leyfð í könnunum.",
  "upload_error.quote": "Innsending skráa er ekki leyfð í tilvitnunum.",
  "upload_form.drag_and_drop.instructions": "Til að taka í myndefnisviðhengi skaltu ýta á bilslána eða Enter. Til að draga geturðu notað örvalyklana til að færa viðhengið í samsvarandi áttir. Ýttu aftur á bilslána eða Enter til að sleppa viðhenginu á nýja staðinn, eða ýttu á Escape til að hætta við.",
  "upload_form.drag_and_drop.on_drag_cancel": "Hætt var við að draga. Myndefnisviðhenginu {item} var sleppt.",
  "upload_form.drag_and_drop.on_drag_end": "Myndefnisviðhenginu {item} var sleppt.",
  "upload_form.drag_and_drop.on_drag_over": "Myndefnisviðhengið {item} var fært.",
  "upload_form.drag_and_drop.on_drag_start": "Tók í myndefnisviðhengið {item}.",
  "upload_form.edit": "Breyta",
  "upload_progress.label": "Er að senda inn...",
  "upload_progress.processing": "Meðhöndla…",
  "username.taken": "Þetta notandanafn er frátekið. Prófaðu eitthvað annað",
  "video.close": "Loka myndskeiði",
  "video.download": "Sækja skrá",
  "video.exit_fullscreen": "Hætta í skjáfylli",
  "video.expand": "Stækka myndskeið",
  "video.fullscreen": "Skjáfylli",
  "video.hide": "Fela myndskeið",
  "video.mute": "Þagga niður",
  "video.pause": "Gera hlé",
  "video.play": "Spila",
  "video.skip_backward": "Stökkva til baka",
  "video.skip_forward": "Stökkva áfram",
  "video.unmute": "Hætta að þagga",
  "video.volume_down": "Lækka hljóðstyrk",
  "video.volume_up": "Hækka hljóðstyrk",
  "visibility_modal.button_title": "Stilla sýnileika",
  "visibility_modal.direct_quote_warning.text": "Ef þú vistar þessa stillingu, þá verður ívöfnu tilvitnuninni breytt í tengil.",
  "visibility_modal.direct_quote_warning.title": "Ekki er hægt að ívefja tilvitnanir í beinu einkaspjalli",
  "visibility_modal.header": "Sýnileiki og gagnvirkni",
  "visibility_modal.helper.direct_quoting": "Ekki er hægt að vitna í einkaspjall sem skrifað er á Mastodon.",
  "visibility_modal.helper.privacy_editing": "Ekki er hægt að breyta sýnileika færslu eftir að hún hefur verið birt.",
  "visibility_modal.helper.privacy_private_self_quote": "Tilvitnanir í sjálfan sig úr einkaspjallfærslum er ekki hægt að gera opinberar.",
  "visibility_modal.helper.private_quoting": "Ekki er hægt að vitna í færslur einungis til fylgjenda sem skrifaðar eru á Mastodon.",
  "visibility_modal.helper.unlisted_quoting": "Þegar fólk vitnar í þig verða færslurnar þeirr einnig faldar á vinsældatímalínum.",
  "visibility_modal.instructions": "Stýrðu því hverjir geta átt við þessa færslu. Þú getur líka ákvarðað stillingar fyrir allar færslur í framtíðinni með því að fara í <link>Kjörstillingar > Sjálfgefin gildi við gerð færslna</link>.",
  "visibility_modal.privacy_label": "Sýnileiki",
  "visibility_modal.quote_followers": "Einungis fylgjendur",
  "visibility_modal.quote_label": "Hverjir geta gert tilvitnanir",
  "visibility_modal.quote_nobody": "Bara ég",
  "visibility_modal.quote_public": "Hver sem er",
  "visibility_modal.save": "Vista"
}
